angular.module('rings-app.directives', ['usersService'])
/*
* Directive to display form to change the user
*/
.directive('changePasswordForm', ['usersService','$rootScope','$state','$filter',function(usersService, $rootScope, $state, $filter){
  return {
    restrict: 'AE',
    templateUrl : 'pages/change-password-form.tpl.html',
    scope : {	}, 																						// isolated scope
    controllerAs : 'PwdFormCtrl',
    bindToController: true,
    controller : function (){

    	// variables
    	var self = this;
    	self.password = {
    		original : null,
    		new : null,
    		confirm : null
    		//error : null
    	};

    	/*
    	* change paswword on server
    	*/
    	this.changePassword = function(){

    		var msg = "Změna hesla v aplikaci Rings provede změnu hesla ve všech aplikacích na birds.cz! Určitě chcete změnu provést?";
    		if (confirm(msg)){
    			// construct JSON object to send to server
				    var body = {
				    	UID: $rootScope.user.UID, 
				    	NewPassword: self.password.new, 
				    	OldPassword: self.password.original
				    };

				    // send to server
				    usersService.changePassword(body).then(
					    function(data) {
					      if (typeof data.error !== 'undefined') {      // error
					        alert($filter('translate')("SAVE.ERROR"));
					      } else {                                      //  OK
					      	//alert($filter('translate')("SAVE.OK"));

					        // remove data saved in localstorage
					        localStorage.removeItem('userToken');
					        localStorage.removeItem('userInfo');

					        // logout user and redirest to home page
					        $rootScope.ls.userRole = userRoles.public;
					        $rootScope.user = {};
					        $rootScope.ls.isLogged = false;
					        $state.go('app.home');
					      }
					      
					    });
				  }
    		}
		    
    }
  }
}])
/*
* Directive to leaflet maps div
* If user clicks in the map, coordinates and city are retrieved
*/

.directive('leafletMap', ['$cookieStore','$rootScope','leafletMarkerEvents','leafletData',function($cookieStore,$rootScope,leafletMarkerEvents, leafletData){
  return {
    restrict: 'E',
    templateUrl : 'pages/leaflet-map.tpl.html',
    scope : {
    	mapOption : "=",
    	locality : "="
    }, // isolated scope
    controllerAs : 'mapCtrl',
    bindToController: true,
    controller : function ($scope){

    	var self = this;

    	self.markers = {};

    	if (typeof self.locality === 'undefined') {
    		self.locality = new Locality();
    	}
    	if (self.locality.coords.latitude != null){
    		self.mapOption.lat = self.locality.coords.latitude;
    		self.mapOption.lng = self.locality.coords.longitude;
    		self.mapOption.zoom = 16;
    		//
    		self.markers.observation = {
				lat: self.locality.coords.latitude,
				lng: self.locality.coords.longitude,
		       	message: null,
		        draggable: true
			}

    	}    	
        
    	self.layers = {
            baselayers: {
                /*mapycz_Base: {
                    name: 'Základní',
                    url: 'https://mapserver.mapy.cz/base-m/{z}-{x}-{y}',
                    type: 'xyz',
                    layerOptions: {
                    	attribution: '<img src="http://mapy.cz/img/logo-small.svg" style="height: 10px" /> © <a href="//www.seznam.cz" target="_blank">Seznam.cz, a.s.</a>, © <a href="//www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a>'
                    }
                },*/
                /*mapycz_Turist: {
                    name: 'Turistická',
                    url: 'https://mapserver.mapy.cz/wturist-m/{z}-{x}-{y}',
                    type: 'xyz',
                    layerOptions: {
                    	attribution: '<img src="http://mapy.cz/img/logo-small.svg" style="height: 10px" /> © <a href="//www.seznam.cz" target="_blank">Seznam.cz, a.s.</a>, © <a href="//www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a>'
                    }                
                },*/
                leaflet: {
                    name: 'OpenStreetMap',
                    url: 'https://tile.openstreetmap.org/{z}/{x}/{y}.png',
                    type: 'xyz',
                    layerOptions: {
                    	attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                    }                
                },
                mapycz_Aerial: {
                    name: 'Letecká',
                    //url: 'https://mapserver.mapy.cz/bing/{z}-{x}-{y}',
                    url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
                    type: 'xyz',
                    layerOptions: {
                    	//attribution: '<img src="http://mapy.cz/img/logo-small.svg" style="height: 10px" /> © <a href="//www.seznam.cz" target="_blank">Seznam.cz, a.s.</a>, © <a href="//www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a>'
                    	attribution: 'Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community'
                    }
                }   
            }
        };

    	self.events = {
    		map: {
                enable: ['layeradd','zoomstart','zoomend','drag', 'click', 'mousemove','moveend','mouseover'],
                logic: 'emit'
            },
            markers: {
                enable: leafletMarkerEvents.getAvailableEvents(),
            }
    	};

    	// when map is clicked, add or update marker and update location
    	$scope.$on("leafletDirectiveMap.click", function(event, args){
            var leafEvent = args.leafletEvent;
            if (self.mapOption.zoom < 14){
	          return;
	        } else {
		        var lat = leafEvent.latlng.lat,
		        lon = leafEvent.latlng.lng;
		        self.locality.coords.latitude = lat;
		        self.locality.coords.longitude = lon;
		        self.crdsToText();
		        if (angular.equals({}, self.markers)) {
		        	self.markers.observation = {
			    		lat: lat,
			      		lng: lon,
		            	message: null,
		                draggable: true
			    	}
		        } else {
			        self.markers.observation.lat = lat;
			        self.markers.observation.lng = lon;
		        }
		    }
		        
	    });

    	// after dragging event, update location position
	    $scope.$on("leafletDirectiveMarker.dragend", function(event, args){
            var leafEvent = args.leafletEvent.target;

		    var lat = leafEvent._latlng.lat,
		    lon = leafEvent._latlng.lng;
		    self.locality.coords.latitude = lat;
		    self.locality.coords.longitude = lon;
		    self.crdsToText();
		    //$scope.$apply();
		    self.markers.observation.lat = lat;
		    self.markers.observation.lng = lon;
	    });

	    // update crdsText
    	this.crdsToText = function(){
	    	if (typeof self.locality.coords.longitude === 'undefined' || self.locality.coords.longitude == null){
	    		self.locality.crdsText = null;
	    	} else {
	    		self.locality.crdsText = parseFloat(self.locality.coords.latitude).toFixed(5) + ', ' + parseFloat(self.locality.coords.longitude).toFixed(5);
	    	}	    	
	    }

	  },
	  link: function (scope, element, attrs, ctrl) {

	  	scope.$on('locationUpdated', function(event, data) {
			var lat = Number(ctrl.locality.coords.latitude),
		        lon = Number(ctrl.locality.coords.longitude);
		        if (angular.equals({}, ctrl.markers)) {
		        	ctrl.markers.observation = {
			    		lat: lat,
			      		lng: lon,
		            	message: null,
		                draggable: true
			    	}
			    	ctrl.mapOption.lat = lat;
    				ctrl.mapOption.lng = lon;
    				ctrl.mapOption.zoom = 16;
		        } else {
			        ctrl.markers.observation.lat = lat;
			        ctrl.markers.observation.lng = lon;
		        }
		})
	  }
  }
}])
/*
* Directive for ObsList
*/
.directive('observation', ['locationService','observationService','codebookService','usersService','$rootScope','$cookieStore','$state','$location','$anchorScroll','amMoment','myConfig','$timeout',
														function(locationService,observationService,codebookService,usersService,$rootScope,$cookieStore,$state,$location,$anchorScroll,amMoment,myConfig,$timeout){
  return {
    restrict: 'AE',
    templateUrl : 'pages/observation.tpl.html',
    scope : { }, 																						// isolated scope
    controllerAs : 'ObservationCtrl',
    bindToController: true,
    controller : function ($scope){

    	// variables
    	var self = this;
    	self.id = null,
    	self.date = null;
    	self.maxDate = new Date();
    	self.datePickerOpened = false;
    	//self.time = new Time();
    	self.timeFrom = new hhmm();
    	self.timeTo = new hhmm();
    	self.note = null;
    	self.siteSecret = false;
    	self.allSecret = true;
    	var today = moment(new Date());
    	var today2 = moment(new Date());
    	self.dateSiteSecret = today.add(6,'months').toDate();
    	self.dateAllSecret = today2.add(10,'years').toDate();
    	self.siteSecretLevel = 'county';
    	self.locality = new Locality();
    	self.locationFromList = true;
    	self.savingLocality = false;
    	self.showHeader = true;
    	self.dateAccuracy = '0';
    	self.coordinatesAccuracy = null;
    	self.netLength = null;
    	self.details = [];
    	self.codebook = null;
    	self.timecodebook = [];
    	self.doingResolve = false;
    	self.doingCodebookResolve = false;
    	self.doingDeleteResolve = false;
    	self.savingHeader = false;
    	self.q = null;
    	self.error=false;
    	self.openObsList = false;
    	self.isEditable = true;
    	self.complete = $rootScope.user.rings.Complete;
    	self.settings = {
    		SimplifiedRingTypes: false
    	}
    	self.obceUrl = myConfig[$rootScope.user.rings.scheme].obceUrl;
    	self.scheme = $rootScope.user.rings.scheme;

    	self.detail = new Observation($rootScope.user.rings.scheme);
    	// map options
    	self.mapOption = myConfig[$rootScope.user.rings.scheme].mapOption;

    	// add time codebook
	    for (var i = 0; i<25; i++){
		  	var output = (i < 10 ? '0' : '') + i + ':00';
		  	self.timecodebook.push(output);
		}

	    // load data
    	var userId = $rootScope.user.UID;
    	var query = "UID=" + userId;
    	// load locations
    	locationService.fetchUserLocations(query)
	      .then(function(data){
	      	self.locations = data;
	      	if (typeof $state.params.idloc !== 'undefined' && $state.params.idloc !== null){
	      		for (var i=0; i<data.length; i++){
	      			if (data[i]['ID'] == $state.params.idloc){
	      				self.locality = data[i];
	      				self.updateLocation(data[i]);
	      			}
	      		}
	      	}	        
	      }, function(data){
	        alert(data);
	      });

	    usersService.fetchUsersettings("?where=UID is "+$rootScope.user.UID)
		    .then(function(data){
		        if (data.length>0){
			      	self.settings = data[0];
			       	if (data[0].SecretUntil){
			       		var secretUntil = new Date(data[0].SecretUntil);
			       		self.dateAllSecret = secretUntil;
			       	}
		        } else {
		      		self.settings = new Setting($rootScope.user.UID);
		        }        
		    }, function(data){
		      alert("Při načítání dat došlo k chybě");
		  });

	    // load data - codebook
	    self.doingCodebookResolve = true;
    	codebookService.fetchCodebook()
	      .then(function(data){
	        self.codebook = data;
	        self.doingCodebookResolve = false;
	      }, function(data){
	        alert(data);
	        self.doingCodebookResolve = false;
	      });

	    if (typeof $state.params.q !== 'undefined' && $state.params.q !== null && $state.params.q !== ''){
	    	self.q = $state.params.q;
	    }

	    // if ID is provfullRingNumberided, load data
		if (typeof $state.params.id !== 'undefined' && isNumber($state.params.id)){
			self.doingResolve = true;
			self.openObsList = false;
			observationService.getObsItem($state.params.id)
		      .then(function(data){
		      	if (data.error){
		      		self.error=true;
		      	} else {
		      		if (data.length > 0){
			      		self.error=false;
			      		// get actual record - first item in collection
				      	record = data[0];
				      	self.construct(record);
				      	self.detail.placeCode = record.placeCode;
						self.netLength = record.netLength;
						self.coordinatesAccuracy = record.coordinatesAccuracy;
						self.dateAccuracy = record.dateAccuracy;
				      	self.error=false;
		      			self.doingResolve = false;
    					self.showHeader = false;
			      	}
		      	}
		      	
		      }, function(data){
		      	self.doingResolve = false;
		        alert(data);
		      });
			} else {
				self.doingResolve = true;
				observationService.getOpenObsList()
					.then(function(data){
						if (data.length == 0){
							// no open obslists, continus
							self.doingResolve = false;
							self.openObsList = false;
						} else {
							self.openObsList = true;
							var record = data[0];
							self.detail = new Observation($rootScope.user.rings.scheme);
							self.construct(record);
							self.detail.placeCode = record.placeCode;
							self.netLength = record.netLength;
							self.coordinatesAccuracy = record.accuracyCoordinates;
							self.dateAccuracy = record.accuracyDate;
							self.error=false;
				      		self.doingResolve = false;
				      		self.showHeader = !self.showHeader;
					  	    $rootScope.obsFormDirty = false;
						}
					});
				// load not closed obslist
			}

			// watch if form is set pristine
			$scope.$watch('ObservationCtrl.observationForm.$pristine', function(val) {
			  $rootScope.obsFormDirty = (val ? false : true);
			});

			// watch for state change and if the form is dirty, ask for confirmation
			$scope.$on('$stateChangeStart', function(event) {
			    if ($rootScope.obsFormDirty && self.canBeEdited) {
			    	if (!confirm('Opouštíte stránku s rozpracovanými údaji. Neuložené údaje budou ztraceny. Přejete si pokračovat?')){
		          $rootScope.doingResolve = false; 
    					$rootScope.localDoingResolve = false;
		          event.preventDefault();
		          return;
		        }
		      }
			});

			// fill object with data
			self.construct = function(record){
				self.details = record.items;	
				// obslist id		  
			    self.id = record.obsListsId;
			    self.detail.obsListId = record.obsListsId;
			    // ring item id - get from params, if available
			    if($state.params.id){
			  		self.detail.id = $state.params.id;
			    } else {
			  		self.detail.id = null;
			    }
			    // if there is open obsitem, fill from detail
			    if (self.openObsList && record.ringItemId){
			    	self.detail.id = parseInt(record.ringItemId);
			    }
				
				// obslist params
				self.date = new Date(record.date);
				// strip seconds from time
				self.timeFrom = new hhmm();
				self.timeTo = new hhmm();
		    	self.timeFrom.time = (record.timeFrom == null) ? null : record.timeFrom.substring(0,5);
		    	self.timeTo.time = (record.timeTo == null) ? null : record.timeTo.substring(0,5);
		    	self.note = record.note;
		    	self.locality.Name = record.locality;
		    	self.locality.Municipality = record.nazcobe;  
		    	self.locality.KODCOBE = record.kodcobe;
		    	self.locality.ID_MunicipalityPart = record.municipalityId
		    	self.locality.coords.latitude = record.latitude;
		    	self.locality.coords.longitude = record.longitude;  
		    	self.locality.crdsText = self.locality.coords.latitude + ', ' + self.locality.coords.longitude;
		    	self.locality.Note = record.siteNote;
		    	// site secret
		    	self.allSecret = record.allSecret == 1;
		    	self.siteSecret = record.siteSecret == 1;
		    	if (record.siteSecretLevel !== null){
		    		self.siteSecretLevel = record.siteSecretLevel;
		    	} else {
		    		self.siteSecretLevel = 'county';
		    	}
		    	if (self.allSecret == 1){
		    		var today = moment(new Date());
	    			self.dateSiteSecret = today.add(6,'months').toDate();
	    			self.dateAllSecret = new Date(record.secretUntil);
		    	} else if (self.siteSecret == 1){
		    		var today = moment(new Date());
	    			self.dateAllSecret = today.add(10,'years').toDate();
	    			self.dateSiteSecret = new Date(record.secretUntil);
		    	} else {
		    		var today = moment(new Date());
					var today2 = moment(new Date());
					self.dateSiteSecret = today.add(6,'months').toDate();
					self.dateAllSecret = today2.add(10,'years').toDate();
		    	}
	    	
		    	// obsitem params - only if id is given
		    	if (self.detail.id){
		    		self.detail.sex = (record.sex == null) ? null : record.sex.toString();
		    		self.detail.age = record.age;	
		    		// scheme
		    		self.detail.ringingScheme = record.scheme ? record.scheme : $rootScope.user.rings.scheme;
		    		// set ring information, including additional ring information
		    		if (typeof record.species !== 'undefined'){
		    			self.detail.species = record.species;
		    		}
		    		if (self.detail.species.TaxonID === null){
		    			self.detail.speciesUnknown = true;
		    		}
		    		// set additional marks
		    		if (typeof record.additionalMarks !== 'undefined'){
		    			self.detail.additionalMarks = record.additionalMarks;
		    		}
		    		if (record.ringInformation == 2 || record.ringInformation == 3){
		    			self.detail.additionalRingInformation = record.ringInformation;
		    		} else if (record.ringInformation > 3) {
							self.detail.ringInformation = record.ringInformation;
		    		}
		    		// date last change
		    		if (typeof record.lastChange !== 'undefined' && record.lastChange !== null){
		    			self.detail.lastChange = new Date(record.lastChange);
		    		}
		    		// date last change
		    		if (typeof record.lastChangeDiff !== 'undefined' && record.lastChangeDiff !== null){
		    			self.detail.lastChangeDiff = new Date(record.lastChangeDiff);
		    			self.isEditable = record.lastChangeDiff <= myConfig.editableTimeLimit;
		    		}
		    		// set ring numbers
		    		if (self.detail.ringInformation > 3){								// retrap
		    			self.detail.ringNumber1_retrap = record.ringNumber;
		    		} else if (self.detail.ringInformation < 4){					// new ringing
		    			var regex = /^([1-9]{0,1}[a-zA-Z]+)0*([1-9][0-9]*)$/i;     
			        	var match = regex.exec(record.ringNumber);
			        	if (match != null){
			        		self.detail.ringType1 = match[1];
			        		self.detail.ringTypeObj = {Code: null, min: null};
			        		self.detail.ringTypeObj.Code = match[1];
			        		self.detail.ringNumber1 = match[2];
			        		self.detail.ringTypeObj.min = match[2];
			        	}
	    			}
		    		self.detail.markType = record.markType;
		    		self.detail.markColor = record.markColor;
		    		self.detail.ringedLeg = (typeof record.ringedLeg === 'undefined' || record.ringedLeg === null) ? '' : record.ringedLeg.toString();   		
		    		//self.detail.placeCode = record.placeCode;
		    		self.detail.sexingMethod = record.sexingMethod;
		    		self.detail.catchingMethod = record.catchingMethod;
		    		self.detail.catchingLure = record.catchingLure;
		    		self.detail.isInteresting = (record.isInteresting == 1) ? true : false;
		    		self.detail.circumstances = record.circumstances;
		    		self.detail.circumstancesPresumed = (record.circumstancesPresumed == 1) ? true : false;
		    		self.detail.condition = record.cond;
		    		self.detail.status = record.status;
		    		self.detail.manipulated = record.manipulated;
		    		self.detail.movedBeforeEncounter = record.movedBeforeEncounter;
		    		self.detail.pullusAge = (record.pullusAge == 99) ? null : record.pullusAge;
		    		self.detail.pullusAccuracy = record.pullusAccuracy;
		    		//self.detail.dateAccuracy = record.dateAccuracy;
		    		//self.detail.coordinatesAccuracy = record.coordinatesAccuracy;
		    		//self.detail.netLength = record.netLength;
		    		self.detail.note = record.detailNote;
		    		self.detail.photoId = record.photoId;
		    		self.detail.photoName = record.photoName;
		    		if (self.detail.photoName){
		    			self.detail.photoPath = '/userdata/images/'+self.detail.photoName+'.jpg';
		    		}
		    		self.detail.wingLength = record.wingLength;
		    		self.detail.thirdPrimary = record.thirdPrimary;
		    		self.detail.mass = record.mass;
		    		self.detail.time = (record.measurementTime == null || record.measurementTime == '') ? null : record.measurementTime.substring(0,5);
		    		self.detail.hindClaw = record.hindClaw;
	    			self.detail.kipp = record.kipp;
	    			self.detail.billLength = record.billLength;
					self.detail.billMethod = record.billMethod;
					self.detail.totalHeadLength = record.totalHeadLength;
					self.detail.tarsus = record.tarsus;
					self.detail.tarsusMethod = record.tarsusMethod;
					self.detail.tailLength = record.tailLength;
					self.detail.tailDifference = record.tailDifference;
					self.detail.firstLLLength = record.firstLLLength;
					self.detail.rPExtensionLength = record.rPExtensionLength;
					self.detail.secondRLNotchLength = record.secondRLNotchLength;
					self.detail.stateOfWingPoint = record.stateOfWingPoint;
					self.detail.moult = record.moult;
					self.detail.plumageCode = record.plumageCode;
					self.detail.fat = record.fatScore;
					self.detail.pectoralMuscleScore = record.pectoralMuscleScore;
					self.detail.broodPatch = record.broodPatch;
					self.detail.juvenilePatch = (record.juvenilePatch === null) ? '' : record.juvenilePatch.toString();
					self.detail.oldGreaterCoverts = (record.oldGreaterCoverts === null) ? '' : record.oldGreaterCoverts.toString();
					self.detail.carpalCovert = (record.carpalCovert === null) ? '' : record.carpalCovert.toString();
					if (typeof record.primaryMoult !== 'undefined' && record.primaryMoult != null && record.primaryMoult.length === 10){
						self.detail.primaryMoult.v1 = record.primaryMoult.substring(0,1);
						self.detail.primaryMoult.v2 = record.primaryMoult.substring(1,2);
						self.detail.primaryMoult.v3 = record.primaryMoult.substring(2,3);
						self.detail.primaryMoult.v4 = record.primaryMoult.substring(3,4);
						self.detail.primaryMoult.v5 = record.primaryMoult.substring(4,5);
						self.detail.primaryMoult.v6 = record.primaryMoult.substring(5,6);
						self.detail.primaryMoult.v7 = record.primaryMoult.substring(6,7);
						self.detail.primaryMoult.v8 = record.primaryMoult.substring(7,8);
						self.detail.primaryMoult.v9 = record.primaryMoult.substring(8,9);
						self.detail.primaryMoult.v10 = record.primaryMoult.substring(9,10);
					}
					if (typeof record.secondaryMoult !== 'undefined' && record.secondaryMoult != null && record.secondaryMoult.length === 6){
						self.detail.secondaryMoult.v1 = record.secondaryMoult.substring(0,1);
						self.detail.secondaryMoult.v2 = record.secondaryMoult.substring(1,2);
						self.detail.secondaryMoult.v3 = record.secondaryMoult.substring(2,3);
						self.detail.secondaryMoult.v4 = record.secondaryMoult.substring(3,4);
						self.detail.secondaryMoult.v5 = record.secondaryMoult.substring(4,5);
						self.detail.secondaryMoult.v6 = record.secondaryMoult.substring(5,6);
					}
					if (typeof record.alula !== 'undefined' && record.alula != null && record.alula.length == 3){
						self.detail.alula.v1 = record.alula.substring(0,1);
						self.detail.alula.v2 = record.alula.substring(1,2);
						self.detail.alula.v3 = record.alula.substring(2,3);
					}
					self.detail.bloodSample = (record.bloodSample == 1);
					self.detail.featherSample = (record.featherSample == 1);
					self.detail.family = new Family();
					self.detail.family.NumBirds = parseInt(record.broodSize);
					if (record.ringFamilyId != null){
						self.detail.family.ID = record.ringFamilyId;
						self.detail.family.itemId = record.ringFamilyItemId;
						self.detail.family.Description = record.ringFamilyDescription;
						self.detail.family.Closed = parseInt(record.ringFamilyClosed) == 1;
						self.detail.family.role = record.role;
						self.detail.family.ringed = record.ringed;
						self.detail.family.NumBirds = parseInt(record.numBirds);
						self.detail.family.NestNumber = record.nestNumber;
					}		
					// ras
					if (record.ras != null && record.ras.length != 0){
						self.detail.ras = true;
						self.detail.rasProjNumber = record.ras[0].ProjNumber
						self.detail.rasCheckNumber = record.ras[0].CheckNumber;
						self.detail.rasDuration = record.ras[0].CheckDuration;
					}	
					// ces			
					if (record.ces != null && record.ces.length != 0){
						self.detail.ces = true;
						self.detail.cesProjNumber = record.ces[0].ProjNumber
						self.detail.cesCheckNumber = record.ces[0].CheckNumber;
						self.detail.cesNetNumber = record.ces[0].NetNumber;
						self.detail.cesNetLength = record.ces[0].NetLength;
						self.detail.cesMoult = record.ces[0].ID_CesMoult;
						self.detail.cesHabitat = record.ces[0].ID_CesHabitat;
						//self.detail.cesWeightingTime = (record.ces[0].WeightingTime == null || record.ces[0].WeightingTime == '') ? null : record.ces[0].WeightingTime.substring(0,5);
					}
					// aegithalos
					if (record.aegithalos != null && record.aegithalos.length != 0) {
						self.detail.aegithalosHead = record.aegithalos[0].HeadMaskType.toString();
					}
	    	}
	    }

	    // functions
	    // update location when selected from list of project locations
	    this.updateLocation = function(loc) {
	      	if (!loc) {
	      		return;
	      	}
	      	self.locality.coords = {longitude: loc.longitude, latitude: loc.latitude}
	      	$scope.$broadcast('angucomplete-alt:changeInput', 'select-municipality', loc.Municipality);
	      	self.locality.Municipality = loc.Municipality;
	      	self.locality.KODCOBE = loc.KODCOBE;
	      	self.locality.ID_MunicipalityPart = loc.ID_MunicipalityPart;
	      	self.locality.Name = loc.Name;
	      	self.locality.crdsText = parseFloat(self.locality.coords.latitude).toFixed(5) + ', ' + parseFloat(self.locality.coords.longitude).toFixed(5);
	      	// set zoom and center of map
		    self.mapOption.zoom = 16;
		    self.mapOption.lat = self.locality.coords.latitude;
		    self.mapOption.lng = self.locality.coords.longitude;
		    // update accuracy of coordinates
		    self.coordinatesAccuracy = '0';
		    $timeout(function() {
		    	$rootScope.$broadcast('locationUpdated');
		    }, 100);	    
		}

	    // when autocompleter option is selected, update zoom and center of the map
    	this.updateMunicipality = function (selectedValue) {
	        if (selectedValue) { 
	        	var str = selectedValue.originalObject.obec;
	        	self.locality.Municipality = str.substring(0,str.indexOf('['));
	        	self.locality.KODCOBE = selectedValue.originalObject.KODCOBE;
	        	self.locality.ID_MunicipalityPart = selectedValue.originalObject.ID;
		        self.mapOption.lat = selectedValue.originalObject.latitude;
		        self.mapOption.lng = selectedValue.originalObject.longitude;
		        self.mapOption.zoom = 14;   	
	        }
    	};

    	// handle changink secret level
    	self.secretLevelChange = function(level){
    		switch(level){
    			case 'site':
    				if (self.siteSecret){
    					self.allSecret = false;
    				}
    				break;
    			case 'all':
    				if (self.allSecret){
    					self.siteSecret = false;
    				}
    				break;
    		}
    	}

    	// parses text and retrieves coordinates from it
	    this.updateCrds = function(){
	        if (self.locality.crdsText == null || self.locality.crdsText == ''){
	          self.locality.err = false;
	          return;
	        }
	        // example 48.255757N, 17.597398E
	        var regexPattern1 = /^([0-9]{2}\.[0-9]*)N?, ([0-9]{2}\.[0-9]*)E?$/i;
	        // example 50°4'49.008"N, 14°24'37.656"E
	        var regexPattern2 = /^([0-9]{2})°([0-9]{1,2})'([0-9]{1,2}\.?[0-9]+?)"N, ([0-9]{2})°([0-9]{1,2})'([0-9]{1,2}\.?[0-9]+?)"E?$/i;
	        // example N 50°2.96520', E 14°30.58850'
	        var regexPattern3 = /^N ([0-9]{2})°([0-9]{1,2}\.[0-9]+)', E ([0-9]{2})°([0-9]{1,2}\.[0-9]+)'$/i
	        if (regexPattern1.test(self.locality.crdsText)){
	          var match = regexPattern1.exec(self.locality.crdsText);
	          self.locality.coords.longitude = match[2];
	          self.locality.coords.latitude = match[1];
	          self.locality.err = false;
	        } else if (regexPattern2.test(self.locality.crdsText)){
	          var match = regexPattern2.exec(self.locality.crdsText);
	          degreeN = match[1];
	          degreeE = match[4];
	          minuteN = match[2];
	          minuteE = match[5];
	          secondN = match[3];
	          secondE = match[6];
	          var lat = parseFloat(degreeN) + parseFloat(minuteN)/60 + parseFloat(secondN)/3600;
	          var lon = parseFloat(degreeE) + parseFloat(minuteE)/60 + parseFloat(secondE)/3600;
	          self.locality.coords.longitude =lon;
	          self.locality.coords.latitude = lat;
	          self.locality.err = false;
	        } else if (regexPattern3.test(self.locality.crdsText)){
	          var match = regexPattern3.exec(self.locality.crdsText);
	          degreeN = match[1];
	          degreeE = match[3];
	          minuteN = match[2];
	          minuteE = match[4];
	          var lat = parseFloat(degreeN) + parseFloat(minuteN)/60;
	          var lon = parseFloat(degreeE) + parseFloat(minuteE)/60;
	          self.locality.coords.longitude =lon;
	          self.locality.coords.latitude = lat;
	          self.locality.err = false;
	        } else {
	          //self.crdsError = true;
	          self.locality.err = true;
	        }
	        if (!self.locality.err){
	          self.mapOption.lat = parseFloat(self.locality.coords.latitude);
	          self.mapOption.lng = parseFloat(self.locality.coords.longitude);
	          self.mapOption.zoom = 16;
	        }
	        $timeout(function() {
	          $rootScope.$broadcast('locationUpdated');
	        }, 100);
	    };

	    // toggle visibility of header and detail
	    this.editHeader = function(){
	    	self.showHeader = !self.showHeader;
	    }

	    this.addLocality = function(){

	    	if (self.locality.Municipality == null || self.locality.Municipality.lenght == 0){
	    		alert('Obec musí být vyplněna');
	    		return;
	    	} else if (self.locality.Name == null || self.locality.Name.lenght == 0){
	    		alert('Název lokality musí být vyplněn');
	    		return;
	    	} else if (self.locality.coords.latitude == null || self.locality.coords.longitude == null
	    		|| self.locality.coords.latitude.length == 0 || self.locality.coords.longitude.length == 0){
	    		alert('Souřadnice musí být vyplněny');
	    		return;
	    	}

	    	self.savingLocality = true;

	    	var dataToSend = {
    			UID : $rootScope.user.UID,
    			Name : (!self.locality.Name || self.locality.Name.length == 0) ? null : self.locality.Name,
    			Municipality : self.locality.Municipality,
    			KODCOBE: self.locality.KODCOBE,
    			ID_MunicipalityPart: self.locality.ID_MunicipalityPart,
    			Note :  (!self.locality.Note || self.locality.Note.length == 0) ? null : self.locality.Note,
    			latitude : parseFloat(self.locality.coords.latitude).toFixed(5),
    			longitude : parseFloat(self.locality.coords.longitude).toFixed(5),
    		}

    		// send data
    		var result = locationService.saveUserLocation(dataToSend).then(
		  	    function(result) {
		  	    	if (typeof result.error === 'undefined'){
		  	    		var userId = $rootScope.user.UID;
    						var query = "UID=" + userId;
		  	    		locationService.fetchUserLocations(query)
						      .then(function(data){
						        self.locations = data;
						        self.savingLocality = false;
										self.savingLocalitySuccess = true;
						      }, function(data){
						        alert(data);
						      });
							} else {
								self.savingLocality = false;
								self.savingLocalitySuccess = true;
								alert("Při ukládání dat došlo k chybě");
							}
		        });
	    }

	    this.deleteObsList = function(){
	    	if (confirm('Smazáním kroužkovací akce přijdete o veškerá uložená data. Opravdu chcete pokračovat?')){
	    		self.doingDeleteResolve = true;
					observationService.deleteObsList(self.id).then(
			  	    function(result) {
			  	    	self.savingHeader = false;
			  	    	if (typeof result.error !== 'undefined'){
			  	    		self.doingDeleteResolve = false;
			  	    		alert("Chyba: " + JSON.stringify(result.error));
			  	    	} else if (result.ok == 'ok'){
			  	    		self.doingDeleteResolve = false;
			  	    		$state.go('app.user.observation', {}, {reload: true});
			  	    	} else {
			  	    		alert("Neznámá chyba");
			  	    		self.doingDeleteResolve = false;
			  	    	}
			        }
			      );
	    	}
	    }

	    // hide header and show detail
	    this.openDetail = function(){
	    	if (!self.isEditable) {
	    		self.showHeader = !self.showHeader;
			  	$rootScope.obsFormDirty = false;
			  	// scroll to message
				$location.hash('locHeader');
				$anchorScroll();
	    	} else {
	    		// if the user has complete data for year of the obervation, display warning
	    		let cont = true;
	    		if (self.complete >= self.date.getFullYear()) {
	    			cont = confirm('Zadáváte kroužkovací akci z roku, v němž již máte odevzdaná data. Opravdu chcete pokračovat?');
	    		}
	    		if (self.date.getFullYear() < ((new Date()).getFullYear() -10)) {
	    			cont = confirm('Zadáváte kroužkovací akci více než 10 do minulosti - opravdu chcete pokračovat?');	
	    		}
	    		if (!cont) {
	    			return;
	    		}

				self.validate(function(data){
		    		if (data){
		    			self.savingHeader = true;
			    		var dataToSend = {};
			    		// construct object to send
			    		dataToSend['date'] = self.date;
						dataToSend['timeFrom'] = self.timeFrom.time;
						dataToSend['timeTo'] = self.timeTo.time;
						dataToSend['note'] = self.note;
						dataToSend['locality'] = self.locality;
						dataToSend['siteSecret'] = self.siteSecret;
						dataToSend['allSecret'] = self.allSecret;
						if (self.allSecret){
							dataToSend['secretUntil'] = self.dateAllSecret;
						} else if (self.siteSecret){
							dataToSend['secretUntil'] = self.dateSiteSecret;
							dataToSend['siteSecretLevel'] = self.siteSecretLevel;
						} else {
							dataToSend['secretUntil'] = null;
						}						
						dataToSend['user'] = $rootScope.user;
						dataToSend['id'] = self.id;
						dataToSend['crdsAccuracy'] = self.coordinatesAccuracy;
						dataToSend['dateAccuracy'] = self.dateAccuracy;
						dataToSend['netLength'] = self.netLength;
						dataToSend['placeCode'] = self.detail.placeCode;
						// send data
		    			observationService.sendObsList(dataToSend).then(
				  	      function(result) {
				  	    	self.savingHeader = false;
				  	    	if (typeof result.error !== 'undefined'){
				  	    		alert("Chyba: " + result.error);
				  	    	} else if (typeof result.id !== 'undefined'){
				  	    		self.id = result.id;
				  	    		self.detail.placeCode = result.placecode;
				  	    		self.showHeader = !self.showHeader;
				  	    		$rootScope.obsFormDirty = false;
				  	    		// scroll to message
					  	    	$location.hash('locHeader');
					  	    	$anchorScroll();
				  	    	} else {
				  	    		alert("Neznámá chyba");
				  	    	}
				        }
				      );
		    		} else {
		    			self.savingHeader = false;
		    			console.log('err');
		    		}
		    	})
	    	}

	    	
	    }

		this.validate = function(callback){

				// validate netLength
				if (self.netLength !== null && isNaN(self.netLength)){
					alert('Délka sítí musí být zadána jako číslo');
					callback(false);
					return;
				}
				// validate date
				if (self.date == null){						// date not set
					alert('Není vyplněno datum, nebo je v nesprávném formátu. Použijte formát "den.měsíc.rok"!');
					callback(false);
					return;
				} else {
					var dt = new Date(self.date);		// date in incorrect format
					if ( Object.prototype.toString.call(dt) === "[object Date]" 
							&& isNaN(dt.getTime())){
						alert('Zadané datum není ve formátu "den.měsíc.rok"!');
						callback(false);
						return;
					} else {
						var today = new Date();				// date in future
						if (dt > today){
							alert('Nelze zadat datum z budoucnosti!');
							callback(false);
							return;
						}
					}					
				}
				// time validation
				var timeFromValid = self.timeFrom.validate();
				var timeToValid = self.timeTo.validate();
				if (!timeFromValid){
					alert('Čas OD je zadán ve špatném formátu!');
					callback(false);
					return;
				}
				if (!timeToValid){
					alert('Čas DO je zadán ve špatném formátu!');
					callback(false);
					return;
				}
				// is accuracy of coordinates and date set?
				if (!self.coordinatesAccuracy) {
					alert("Přesnot souřadnic musí být zadána");
					callback(false);
					return;
				}
				if (!self.dateAccuracy) {
					alert("Přesnot data musí být zadána");
					callback(false);
					return;
				}
				// does contain :?
				if (self.timeFrom.time && self.timeFrom.time.indexOf(':') != -1){
					// does not contain ':'
					var timeFromDateText = '01/01/2011 '+  self.timeFrom.time + ':00';
				} else {
					var timeFromDateText = '01/01/2011 '+  self.timeFrom.time + ':00:00';
				}
				if (self.timeTo.time && self.timeTo.time.indexOf(':') != -1){
					// does not contain ':'
					var timeToDateText = '01/01/2011 '+  self.timeTo.time + ':00';
				} else {
					var timeToDateText = '01/01/2011 '+  self.timeTo.time + ':00:00';
				}
				if (self.timeFrom.time && self.timeTo.time){
					if ( Date.parse(timeToDateText) <  Date.parse(timeFromDateText)){
						alert('Čas DO nesmí být menší než čas OD!');
						callback(false);
						return;
					}
				}
				
				
				// validate municipality
				if (self.locality.Municipality == null 
					  ||typeof self.locality.Municipality === 'undefined' 
						|| self.locality.Municipality.length == 0){
					alert('Obec musí být vyplněna!');
					callback(false);
					return;
				}
				// validate municipality
				if (self.locality.Name == null 
					  ||typeof self.locality.Name === 'undefined' 
						|| self.locality.Name.length == 0){
					alert('Lokalita musí být vyplněna!');
					callback(false);
					return;
				}
				// validate coordinates
				if ( self.locality.err
						|| typeof self.locality.coords === 'undefined'
					  || self.locality.coords == null
						|| !isNumber(self.locality.coords.latitude)
						|| !isNumber(self.locality.coords.longitude)){
					alert('Souřadnice musí být vyplněny a musí se jednat o čísla!');
					callback(false);
					return;
				}

				callback(true);
	      	return;
		}

    }
  }
}])
/*
* Directive for RingItem
*/
.directive('observationDetail', ['codebookService','observationService','familyService','ringsService','rasService','$rootScope','$state','$location','$anchorScroll','Upload','myConfig','$window','$timeout','$uibModal','$filter',
						function(codebookService,observationService,familyService,ringsService,rasService,$rootScope,$state,$location,$anchorScroll,Upload,myConfig,$window,$timeout,$uibModal,$filter){
  return {
    restrict: 'E',
    templateUrl : 'pages/detail.tpl.html',
    scope : {
    	settings : "=",
    	obsListId : "=",
    	currentDetail: "=detail",
    	details: "=",
    	codebook: "=",
    	q: "=",
    	openObsList: "="
    }, // isolated scope
    controllerAs : 'DetailCtrl',
    bindToController: true,
    controller : function ($scope){

    	// variables
    	var self = this;
    	// autocomplete
    	self.scheme = $rootScope.user.rings.scheme;
		self.druhUrl = myConfig[self.scheme].druhUrl;
    	//self.codebook=null;
    	self.families = null;
    	self.ringTypes = null;
    	self.showAlert = false;
    	self.showCircumstancesDetail = false;
    	self.familyActive = false;
    	self.tab1Active = false;
    	self.tab2Active = false;
    	self.tab3Active = false;
    	self.tab4Active = false;
    	self.tab5Active = false;
    	self.moreInfoActive = false;
    	// loading icon
    	self.doingImgResolve = false;
    	self.doingSavingResolve = false;
    	self.doingRingingDataResolve = false;
    	// can user edit record?
    	self.canBeEdited = true;
    	// can record be deleted - because it is already procesed retrap?
    	self.procesedRetrap = false;
    	// tabs active
    	self.detailsActive = false;
    	self.projectsActive = false;
    	self.biomActive = false;
    	self.qualityActive = false;
    	self.focusRn = false;
    	self.repeated = false;
    	// modal window
    	self.modalInstance;
    	self.ringingInfo;
    	self.ringingInfoRetraps;
    	self.noRingingInfo = false;
    	self.rasProjects = [];

    	if (typeof self.currentDetail === 'undefined'){
    		self.currentDetail = new Observation($rootScope.user.rings.scheme);
    	}

    	if (typeof self.details === 'undefined'){
    		self.details=[];
    	}

    	// watch if form is set pristine
		$scope.$watch('DetailCtrl.detailForm.$pristine', function(val) {
		  $rootScope.detailFormDirty = (val ? false : true);
		});

		rasService.getRasProjects('?where=Active is 1 and ID_RingingScheme is \'' + $rootScope.user.rings.scheme + "'")
			.then(function(data){
				self.rasProjects = data;
			});

		rasService.getCesProjects('?where=Active is 1 and ID_RingingScheme is \'' + $rootScope.user.rings.scheme + "'")
			.then(function(data){
				self.cesProjects = data;
			});

    	// can record be edited?
        self.isEditable = function(){
	      	//return if obslist open;
	      	if (self.openObsList) {
	      		return true;
	      	} else {
	      		return self.currentDetail.lastChangeDiff <= myConfig.editableTimeLimit;	
	      	}	      	
	        /*var today = new Date();
	        var timeDiff = Math.abs(self.currentDetail.lastChange.getTime() - today.getTime());
	        var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
	        if (diffDays <= myConfig.editableTimeLimit){
	          return true;
	        } else {
	          return false;
	        }*/
        }

    	// init circumstances - get parent
		this.initCircumstances = function(){
			if (self.currentDetail.circumstances !== null){
			    var parent =  self.codebook.circumstances.find(x=> x.Code === self.currentDetail.circumstances).ParentCode;
			  	//set circumstancesParent
			   	if (parent === null){
			  		self.currentDetail.circumstancesParent = self.currentDetail.circumstances;
			  	} else {
			     	self.currentDetail.circumstancesParent = parent;
			    } 
		    }
		}

    	if (self.codebook==null){
    		// load data - codebook
	    	codebookService.fetchCodebook()
		      .then(function(data){
		        self.codebook = data;
		        if (self.currentDetail.circumstances !== null){
				      var parent =  self.codebook.circumstances.find(x=> x.Code === self.currentDetail.circumstances).ParentCode;
				    	//set circumstancesParent
					   	if (parent === null){
					  		self.currentDetail.circumstancesParent = self.currentDetail.circumstances;
					  	} else {
					     	self.currentDetail.circumstancesParent = parent;
					    } 
				    }
		      }, function(data){
		        alert(data);
		      });
    	} else {
    		if (self.currentDetail.circumstances !== null){
		      var parent =  self.codebook.circumstances.find(x=> x.Code === self.currentDetail.circumstances).ParentCode;
		    	//set circumstancesParent
			   	if (parent === null){
			  		self.currentDetail.circumstancesParent = self.currentDetail.circumstances;
			  	} else {
			     	self.currentDetail.circumstancesParent = parent;
			    } 
		    }
    	}
    	
    	self.ringInformation = [
        {"code": 1,"description": "Nové kroužkování"}
        ,{"code": 4,"description": "Kroužek již přítomen"}
        ,{"code": 6,"description": "Odstranění kroužku"}];
        self.cesDurationCodebook = [1,2,3,4,5,6,7,8];

	    // load available rings
	    var userId = $rootScope.user.UID;
	    self.additionalUrl = 'user=' + userId + '&scheme=' + $rootScope.user.rings.scheme + "&simplified="+self.settings.SimplifiedRingTypes;
	    // watch if settings change (after they are aloaded from server)
		$scope.$watch('DetailCtrl.settings', function(val) {
		  self.additionalUrl = 'user=' + userId + '&scheme=' + $rootScope.user.rings.scheme + "&simplified="+self.settings.SimplifiedRingTypes;
		});

    	if (self.currentDetail.id != null && self.currentDetail.family.ID != null){
    		self.families = [self.currentDetail.family];
    	} else {
		    // load family
		    var userId = $rootScope.user.UID;
		    var additionalUrl = '?where=ID_User is ' + userId;
	    	familyService.fetchFamiliesSimple(additionalUrl)
		      .then(function(data){
		        self.families = data;
		      }, function(data){
		        alert(data);
		      });
    	}

    	// if the id is given, user is editing - no need to fill ringtypes
    	if (self.currentDetail.id != null){
    		self.ringTypes = [self.currentDetail.ringTypeObj];
    		// uncomment when editing should be disabled
    		self.canBeEdited = self.isEditable();
    		// check, if retrap can be edited
    		if (self.currentDetail.ringInformation > 3) {
    			observationService.fetchRetrapItems('?where=ID_Retrap is ' + self.currentDetail.id)
    				.then(function(data){
    					if (data[0].ID_RetrapType !== 'U') {
    						self.procesedRetrap = true;
    					}
    				}, function(err){
				        alert(err);
				    })
    		}
    	// new record - populate ringTypes
    	} else {
    		//var url = self.additionalUrl + ' and Status3 > 0';
    		ringsService.fetchRingsSeries(self.additionalUrl)
			    .then(function(data){
			      self.ringTypes = data;
			    }, function(data){
			      alert("Při načítání dat došlo k chybě");
			  	});
    	}

    	self.closeAllTabs = function(){
    		self.tab1Active = false;
    		self.tab2Active = false;
    		self.tab3Active = false;
    		self.tab4Active = false;
    		self.tab5Active = false;
    		self.familyActive = false;
    	}

    	// after num birds is left, change closed to true, if there is only one bird
    	this.familyNumBirdsBlur = function() {
    		if (this.currentDetail.family.NumBirds === 1) {
    			this.currentDetail.family.Closed = true;
    		}
    	};

    	// if age is changed to pull, switch to family tab
    	this.changeAge = function(){
    		if (self.currentDetail.age === 200){
    			self.familyActive = true;
    			self.moreInfoActive = true;
    			self.currentDetail.status = '-';
    		} else if (self.currentDetail.status === '-') {
    			self.currentDetail.status = 'U';
    		} else {
    			// if not pullus and status pullus, set unknown
    			if (self.currentDetail.status === '-') {
    				self.currentDetail.status = 'U';
    			}
    		}
    	}

    	this.tarsusChanged = function() {
    		if (self.currentDetail.tarsus && self.currentDetail.tarsusMethod === null) {
    			if (self.settings.TarsusMethod) {
    				self.currentDetail.tarsusMethod = self.settings.TarsusMethod;
    			}
    		}
    	}

    	this.billChanged = function() {
    		if (self.currentDetail.billLength && self.currentDetail.billMethod === null) {
    			if (self.settings.BillMethod) {
    				self.currentDetail.billMethod = self.settings.BillMethod;
    			}
    		}
    	}

    	// if sex is changed to U, switch sexingmethod to unknown
    	this.changeSex = function(){
    		if (parseInt(self.currentDetail.sex) === 5){
    			self.currentDetail.sexingMethod = 'U';
    		}
    	}

    	// when circumstances are changed, check, if parent code starts with P. if not, set it as circumstances
    	this.changeCircumstances = function(){
    		if (typeof self.currentDetail.circumstancesParent !== 'undefined' && self.currentDetail.circumstancesParent.startsWith('P') != true){
	          self.showCircumstancesDetail = false;
	          self.currentDetail.circumstances = self.currentDetail.circumstancesParent;
	        } else {
	          self.showCircumstancesDetail = true;
	        }
	        if (self.currentDetail.circumstances === '02') {
	        	self.currentDetail.speciesUnknown = true;
	        	self.speciesUnknown();
	        }
    	}

    	self.changeCircumstances();

    	// upload on file select or drop
	    this.uploadFile = function (file) {
	    	self.doingImgResolve = true;
	        Upload.upload({
	            //url: myConfig.apiUrl + 'rings/image',
	            url: 'https://rings.birds.cz/proxy/v1/rings/image',
	            data: {file: file}
	        }).then(function (resp) {
	        	self.doingImgResolve = false;
	        	self.currentDetail.photoId = resp.data.id;
	        	self.currentDetail.photoName = resp.data.name;
	        	self.currentDetail.photoPath = '/userdata/images/'+self.currentDetail.photoName+'.jpg';
	        }
	        , function (resp) {
	        	alert('Při nahrávání fotografie došlo k chybě');
	        	self.doingImgResolve = false;
	            console.log('Error status: ' + resp.status);
	        }
	        , function (evt) {
	        	// TODO - progress bar
	          //var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
	        });
	    };

	    this.deleteFile = function(){
	    	self.currentDetail.photoId = null;
	    	alert('Pro povrzení smazání fotografie uložte záznam')
	    }

	    self.htmlTemplate = function(photopath){
        	var html = '<div><a href="/img/'+photopath+'" target="_blank"><img src="/img/'+photopath+'" class="img-responsive"></a></div>';
        	return html;
        }

	      // reload data from server
	    this.updateFamilies = function(){
	    	var userId = $rootScope.user.UID;
		    var additionalUrl = '?where=ID_User is ' + userId;
	    	familyService.fetchFamiliesSimple(additionalUrl)
		      .then(function(data){
		        self.families = data;
		      }, function(data){
		        alert(data);
		      });
	    }

	    // set ringtype object
	    this.checkRingTypes = function(){
	    	// if tringtypes are simplified, check only type
	    	if (self.settings.SimplifiedRingTypes){
	    		if (self.ringTypes != null && self.ringTypes.length > 0){
			    	for (var i = 0; i < self.ringTypes.length; i++){
			    		if (self.ringTypes[i].Code == self.currentDetail.ringType1){
			    			self.currentDetail.ringNumber1 = parseInt(self.currentDetail.ringNumber1) +1;
			    			self.currentDetail.ringTypeObj = self.ringTypes[i];
			    			return;
			    		}
			    	}
			    }
	    	} else {
	    		// if tringtypes full, check against type and number
	    		if (self.ringTypes != null && self.ringTypes.length > 0){
			    	for (var i = 0; i < self.ringTypes.length; i++){
			    		if (self.ringTypes[i].Code == self.currentDetail.ringType1
			    			&& (parseInt(self.currentDetail.ringNumber1) +1) == self.ringTypes[i].min){
			    			self.currentDetail.ringNumber1 = self.ringTypes[i].min;
			    			self.currentDetail.ringTypeObj = self.ringTypes[i];
			    			return;
			    		}
			    	}
			    }
	    	}
	    	   
		    // if not found reset ringtype, ring number and ringtypeobj
		    self.currentDetail.ringTypeObj = null;
		    self.currentDetail.ringType1 = null;
		    self.currentDetail.ringNumber1 = null;
	    }

	    // load ringtypes
	    this.updateRingTypes = function(){
	    	var t1 = new Date();
	    	ringsService.fetchRingsSeries(self.additionalUrl)
			    .then(function(data){
			    	var t2 = new Date();
			    	var dif = t2.getTime() - t1.getTime();
			      self.ringTypes = data;
			      self.checkRingTypes();
			    }, function(data){
			      alert("Při načítání dat došlo k chybě");
			  	});
	    }

	    // update family from list, set role to sibling and possibly set 'closed' indicator to true
	    this.updateFamily = function(family){
	    	self.currentDetail.family.role = 'sibling';
	    	self.currentDetail.newFamily = false;
	    	self.currentDetail.family.NestNumber = family.NestNumber;
	    	//self.currentDetail.family.ID = 0;
	    	if (self.currentDetail.family.NumBirds == self.currentDetail.family.ringed + 1){
	    		self.currentDetail.family.Closed = true;
	    	}
	    }

	    // when the 'new family' button is clicked, create new family
	    this.newFamily = function($event){
	    	var checkbox = $event.target;
				var action = (checkbox.checked ? 'add' : 'remove');
	    	if (action == 'add') {
				self.currentDetail.family = new Family();
	    	}
	    }

	    // when the ringtype is changed, set id ringtype and first available ring
	    this.changeRingType = function(){
	    	self.currentDetail.ringType1 = self.currentDetail.ringTypeObj.Code;
	    	self.currentDetail.ringNumber1 = self.currentDetail.ringTypeObj.min;
	    }

    	// functions
    	// when autocompleter option is selected, update model
    	this.updateSpecies = function (selectedValue) {
	        if (!selectedValue) {
	            self.currentDetail.species = {TaxonID: null,Name:null,Fullname:null,isWader:null};
	            return;
	        }
	        self.currentDetail.species = selectedValue.originalObject; 
	        self.currentDetail.speciesUnknown = false;
    	};

    	this.speciesUnknown = function(){
    		if (self.currentDetail.speciesUnknown){
    			$rootScope.$broadcast('angucomplete-alt:clearInput');
    		}
    	}

    	// if type is 'new ringing'
    	this.changeRingingInformation = function() {
	      if (self.currentDetail.ringInformation == 1) {
	        self.currentDetail.ringingScheme = self.scheme;
	        self.currentDetail.circumstances = "20";
	        self.currentDetail.circumstancesParent="20";
	        self.currentDetail.condition=8;
	        self.retrapMessage = false;
	      } else {
	      	self.currentDetail.circumstancesParent='';
	        self.currentDetail.circumstances=null;
	      }
	    }

	    // if CES moult is changed, change moult
	    this.changeCesMoult = function(){
	    	switch(self.currentDetail.cesMoult){
	    		case 'J':
	    			self.currentDetail.moult = 'J';
	    			break;
	    		case 'P':
	    			self.currentDetail.moult = 'P';
	    			break;
	    		case 'T':
	    			self.currentDetail.moult = 'P';
	    			break;
	    		case 'B':
	    			self.currentDetail.moult = 'B';
	    			break;
	    		case 'M':
	    			self.currentDetail.moult = 'M';
	    			break;
	    		case 'S':
	    			self.currentDetail.moult = 'M';
	    			break;
	    		case 'E':
	    			self.currentDetail.moult = 'M';
	    			break;
	    		case 'O':
	    			self.currentDetail.moult = 'X';
	    			break;
	    		case 'N':
	    			self.currentDetail.moult = 'X';
	    			break;
	    		case 'A':
	    			self.currentDetail.moult = 'X';
	    			break;
	    	}
	    }

		// return class for color - required based on markType
		this.colorRequired = function(){
			// if the marktype is one of the following, set as required
			if (['B0','C0','D0','H0'].indexOf(self.currentDetail.markType) != -1){
				return 'required';
			} else {
				return null;
			}
		}

		// loads last retrap of ring from server
		this.getRingingData = function(){
			if (self.currentDetail.ringNumber1_retrap != null && self.currentDetail.ringNumber1_retrap.length > 0){
				self.doingRingingDataResolve = true;
				var rn = self.currentDetail.ringNumber1_retrap.replace(/\s/g,'');
				//var fullrn = fullRingNumber(rn);
				let bothRns = ringNumberLeadingZeroes(rn);
				var additionalUrl = "?where=methodId is 'A0' and scheme='" + $rootScope.user.rings.scheme + "' and owner is '" + $rootScope.user.User +"'";
				additionalUrl += " and (ringNumber is '" + bothRns[0] + "' or ringNumber is '" + + bothRns[1] + "')";
				observationService.getRingingHistoryDetail(additionalUrl)
					.then(function(data){

						var showModalWindow = false;
						var ringingId;

						var retraps = [];
						for (var i = 0; i < data.length; i++){
							if (data[i].ringInformationId < 4){
								showModalWindow = true;
								ringingId = i;
							} else {
								retraps.push(data[i])
							}
						}

						if (showModalWindow){
							self.noRingingInfo = false;
							var modalScope = $scope.$new();
							self.ringingInfo = data[ringingId];
							self.ringingInfoRetraps = retraps//clonedData.splice(ringingId,1);

							// set species, if not set
							//if (!self.currentDetail.species || !self.currentDetail.species.TaxonID){


							self.currentDetail.species = {TaxonID: data[ringingId].speciesId,Name:data[ringingId].speciesName,Fullname:data[ringingId].speciesName,isWader:null};
        					$scope.$broadcast('angucomplete-alt:changeInput', 'species', data[ringingId].speciesName); 
							//}
        
					        self.modalInstance = $uibModal.open({
					          template: '<ringing-info-modal-window ringing="DetailCtrl.ringingInfo" retraps="DetailCtrl.ringingInfoRetraps" instance="DetailCtrl.modalInstance"></ringing-info-modal-window>',
					          size: 'md',
					          scope: modalScope
					        });
						} else {
							self.noRingingInfo = true;
						}

						self.doingRingingDataResolve = false;
			    }, function(data){
			    	self.doingRingingDataResolve = false;
			      alert("Při načítání dat došlo k chybě");
			  	});
			}
		}

		this.openSelectFamilyModalWindow = function() {
		  var modalScope = $scope.$new();

		  self.modalInstance = $uibModal.open({
		  template: '<select-family-modal-window instance="DetailCtrl.modalInstance"></select-family-modal-window>',
		    size: 'md',
		    scope: modalScope
		  });

		  self.modalInstance.result.then(function (selectedItem) {
		      //$ctrl.selected = selectedItem;
		      self.families.push(selectedItem);
		      self.currentDetail.family = selectedItem;
		      self.updateFamily(selectedItem);
		    }, function () {
		      //$log.info('Modal dismissed at: ' + new Date());
		    });
		};

			// validation
		this.validate = function(){
			// validate header
			// validate ringOperation
			if (self.currentDetail.ringInformation == null){
				alert('Typ operace musí být vyplněn');
				return false;
			}
			// validate ringingScheme
			if (self.currentDetail.markType == 'A0' && self.currentDetail.ringingScheme == null){
				alert('Stanice musí být vyplněna');
				return false;
			}
			if ((self.currentDetail.ringInformation == 1 && self.currentDetail.ringingScheme !== $rootScope.user.rings.scheme)){
				alert('Nelze kroužkovat kroužky z jiné stanice než Praha');
				return false;
			}
			// validate mark color - main identification mark
	    	if (['B0','C0','D0','H0'].indexOf(self.currentDetail.markType) != -1
				&& self.currentDetail.markColor == null){
				alert('Barva musí být vyplněna');
				return false;
			}
			// validate mark color of additional marks
			for (var i = 0; i < self.currentDetail.additionalMarks.length; i++){
				var mark = self.currentDetail.additionalMarks[i];
				if (['B0','C0','D0','H0'].indexOf(mark.markType) != -1
					&& mark.markColor == null){
					alert('Barva přídatné identifikační značky musí být vyplněna');
					return false;
				} 
			}
			// validate markType of additional marks
			for (var i = 0; i < self.currentDetail.additionalMarks.length; i++){
				var mark = self.currentDetail.additionalMarks[i];
				if (mark.markType == null){
					alert('Typ přídatné identifikační značky musí být vyplněn');
					return false;
				} 
			}
			// validate sex
			if (self.currentDetail.sex == null){
				alert('Pohlaví musí být vyplněno');
				return false;
			}
			// validate age
			if (self.currentDetail.age == null && self.currentDetail.ringInformation != 4){
				alert('Věk musí být vyplněn. Pokud si nejste jistí přesným věkem, vyplňte jen, zda se jednalo o pullus nebo dospělého jedince');
				return false;
			}
			// validate species
			if ((self.currentDetail.species == null || self.currentDetail.species.TaxonID == null) && self.currentDetail.ringInformation != 4){
				alert('Druh musí být vyplněn. Vyberte ze seznamu, nikoli vepsáním názvu do textového pole');
				return false;
			}
			// validate ring number
			// new ring
			if (['A0','B0','C0'].indexOf(self.currentDetail.markType) !== -1){
				if (self.currentDetail.ringInformation == 1){
					if (self.currentDetail.ringType1 == null || self.currentDetail.ringNumber1 == null){
						alert('Musí být vyplněno číslo kroužku');
						return false;
					}
				// re-ringing
				} else {
					if (self.currentDetail.ringNumber1_retrap == null || self.currentDetail.ringNumber1_retrap.length == 0){
						alert('Musí být vyplněno číslo kroužku');
						return false;
					}
				}
			}
			// validate ringnumber - only letters and numbers
			if (self.currentDetail.markType == 'A0' 
				&& self.currentDetail.ringInformation > 3 
				&& self.currentDetail.ringingScheme === $rootScope.user.rings.scheme){
				var regexPattern = /^[1-9]?[a-zA-Z]{1,2}0*[0-9]+$/i;
				if (!regexPattern.test(self.currentDetail.ringNumber1_retrap)){
					alert('Číslo kroužku může obsahovat pouze písmena a čísla');
					return false;
				}
			}
				
			// additional information
			// circumstances are required for retrap
			if (self.currentDetail.ringInformation > 3 && self.currentDetail.circumstances == null){
				alert('Pole "Okolnosti" je povinné, pokud se jedná o zpětný odchyt');
				return false;
			}
			// circumstances
			if (self.currentDetail.circumstances != null 
				  && !isNumber(self.currentDetail.circumstances)){
				alert('Neplatná hodnota pole "Okolnosti"');
				return false;
			} else if (parseFloat(self.currentDetail.circumstances) < 0 || parseFloat(self.currentDetail.circumstances) > 99){
				alert('Neplatná hodnota pole "Okolnosti"');
				return false;
			}

			// pullus age format
			if (self.currentDetail.pullusAge){
				var regex = /^\d{1,2}$/;
				if (!regex.test(self.currentDetail.pullusAge)){
					alert('Neplatná hodnota pole "Věk pullus". Musí se jednat o celé číslo');
					return false;
				}
			}
			// biometrics
			// wing length
			if (self.currentDetail.wingLength != null 
				  && (!isNumber(self.currentDetail.wingLength) || parseFloat(self.currentDetail.wingLength) < 0)){
				alert('Neplatná hodnota pole "Délka křídla"');
				return false;
			}
			// thirdPrimary
			if (self.currentDetail.thirdPrimary != null 
				  && (!isNumber(self.currentDetail.thirdPrimary) || parseFloat(self.currentDetail.thirdPrimary) < 0)){
				alert('Neplatná hodnota pole "thirdPrimary"');
				return false;
			}
			// mass
			if (self.currentDetail.mass != null 
				&& (!isNumber(self.currentDetail.mass) || parseFloat(self.currentDetail.mass) < 0)){
				alert('Neplatná hodnota pole "Hmotnost"');
				return false;	
			}
			// if mass is set, weighting time is mandatory
			if (self.currentDetail.mass != null) {
				if (self.currentDetail.time === null || self.currentDetail.time === '') {
					alert('Pokud je vyplněna hmotnost, musí být vyplněn i čas odchytu. Pokud nevíte přesný čas, uveďte odhad.');
					return false;
				}
			}
			// time of measurement
			if (self.currentDetail.time != null && self.currentDetail.time != ''){
				var regexPattern = /^([0-9]|0[0-9]|1[0-9]|2[0-3])(:[0-5][0-9])?$/i;
				if (!regexPattern.test(self.currentDetail.time)){
					alert('Hodnota "Čas odchytu" má nesprávný formát');
					return false;
				}
			}			
			// tces weighting time
			/*if (self.currentDetail.cesWeightingTime != null && self.currentDetail.cesWeightingTime != ''){
				var regexPattern = /^([0-9]|0[0-9]|1[0-9]|2[0-3])(:[0-5][0-9])?$/i;
				if (!regexPattern.test(self.currentDetail.cesWeightingTime)){
					alert('Hodnota "Čas vážení" má nesprávný formát');
					return false;
				}
			}	*/
			// hindClaw
			if (self.currentDetail.hindClaw != null 
				  && (!isNumber(self.currentDetail.hindClaw) || parseFloat(self.currentDetail.hindClaw) < 0)){
				alert('Neplatná hodnota pole "Zadní dráp"');
				return false;
			}
			// kipp
			if (self.currentDetail.kipp != null 
				  && (!isNumber(self.currentDetail.kipp) || parseFloat(self.currentDetail.kipp) < 0)){
				alert('Neplatná hodnota pole "Kippův index"');
				return false;
			}
			// billLength
			if (self.currentDetail.billLength != null 
				  && (!isNumber(self.currentDetail.billLength) || parseFloat(self.currentDetail.billLength) < 0)){
				alert('Neplatná hodnota pole "Délka zobáku"');
				return false;
			}
			// bill method
			/*if (self.currentDetail.id){
				if (self.currentDetail.billLength != null && self.currentDetail.billLength > 0 && self.currentDetail.billMethod == null){
					alert('Pole "metoda měření zobáku" je povinné, pokud je vyplněna délka zobáku');
					return false;
				}
			}*/
			// totalHeadLength
			if (self.currentDetail.totalHeadLength != null 
				  && (!isNumber(self.currentDetail.totalHeadLength) || parseFloat(self.currentDetail.totalHeadLength) < 0)){
				alert('Neplatná hodnota pole "Délka hlavy"');
				return false;
			}
			// totalHeadLength
			if (self.currentDetail.tarsus != null 
				&& (!isNumber(self.currentDetail.tarsus) || parseFloat(self.currentDetail.tarsus) < 0)){
				alert('Neplatná hodnota pole "Délka tarsu"');
				return false;
			}
			// tarsusMethod
			/*if (self.currentDetail.id){
				if (self.currentDetail.tarsus != null && self.currentDetail.tarsus > 0 && self.currentDetail.tarsusMethod == null){
					alert('Pole "metoda měření tarsu" je povinné, pokud je vyplněna délka tarsu');
					return false;
				}
			}*/
				
			// tailLength
			if (self.currentDetail.tailLength != null 
				&& (!isNumber(self.currentDetail.tailLength) || parseFloat(self.currentDetail.tailLength) < 0)){
				alert('Neplatná hodnota pole "Délka ocasu"');
				return false;
			}
    		// tailDifference
			if (self.currentDetail.tailDifference != null 
				  && (!isNumber(self.currentDetail.tailDifference) || parseFloat(self.currentDetail.tailDifference) < 0)){
				alert('Neplatná hodnota pole "tailDifference"');
				return false;
			}
			// old greater coverts
			if (self.currentDetail.oldGreaterCoverts != null && self.currentDetail.oldGreaterCoverts != ''
				  && (!isNumber(self.currentDetail.oldGreaterCoverts) || parseFloat(self.currentDetail.oldGreaterCoverts) < 0)){
				alert('Neplatná hodnota pole "oldGreaterCoverts"');
				return false;
			}

			// qualitative fields
			var alula = [self.currentDetail.alula.v1,self.currentDetail.alula.v2,self.currentDetail.alula.v3];
			// is any of the values not null?
			if (alula.indexOf(null) != -1){
				var allNull = true;
				for (i=0;i<alula.length;++i){
					if (alula[i] == null){
						if (!allNull){
							alert('Všechny hodnoty pole Alula musí být vyplněny');
							return false;
						}							
					} else {
						allNull = false;
					}
				}
			}
			// primary moult
			var pm = [self.currentDetail.primaryMoult.v1,self.currentDetail.primaryMoult.v2,
				self.currentDetail.primaryMoult.v3,self.currentDetail.primaryMoult.v4,
				self.currentDetail.primaryMoult.v5,self.currentDetail.primaryMoult.v6,
	    		self.currentDetail.primaryMoult.v7,self.currentDetail.primaryMoult.v8,
		    	self.currentDetail.primaryMoult.v9,self.currentDetail.primaryMoult.v10];
			// is any of the values not null?
			if (pm.indexOf(null) != -1){
				var allNull = true;
				for (i=0;i<pm.length;++i){
					if (pm[i] == null){
						if (!allNull){
							alert('Všechny hodnoty pole "Pelichání RL" musí být vyplněny');
							return false;
						}							
					} else {
						allNull = false;
					}
				}
			}
			// secondary moult
			var pm = [self.currentDetail.secondaryMoult.v1,self.currentDetail.secondaryMoult.v2,
				self.currentDetail.secondaryMoult.v3,self.currentDetail.secondaryMoult.v4,
				self.currentDetail.secondaryMoult.v5,self.currentDetail.secondaryMoult.v6];
			// is any of the values not null?
			if (pm.indexOf(null) != -1){
				var allNull = true;
				for (i=0;i<pm.length;++i){
					if (pm[i] == null){
						if (!allNull){
							alert('Všechny hodnoty pole "Pelichání LL" musí být vyplněny');
							return false;
						}							
					} else {
						allNull = false;
					}
				}
			}
			// CES
			if (self.currentDetail.ces){
				// check number
				if (self.currentDetail.cesCheckNumber == null || self.currentDetail.cesCheckNumber.length == 0){
					alert('Hodnota pole "Číslo kontroly CES" musí být vyplněna');
					return false;
				}
				// proj number
				if (self.currentDetail.cesProjNumber == null || self.currentDetail.cesProjNumber.length == 0){
					alert('Hodnota pole "Číslo projektu CES" musí být vyplněna');
					return false;
				}
				// brood patch
				if (self.currentDetail.broodPatch == null || self.currentDetail.broodPatch.length == 0){
					alert('Hodnota pole "Hnízdní nažina" musí být vyplněna');
					return false;
				}
				// fat
				if (self.currentDetail.fat == null || self.currentDetail.fat.length == 0){
					alert('Hodnota pole "Tuk" musí být vyplněna');
					return false;
				}
				// measurement time - format is validate elsewhere
				if (self.currentDetail.time == null || self.currentDetail.time.length == 0){
					alert('Hodnota pole "Čas oschytu" musí být vyplněna');
					return false;
				}
				// ces moult
				if (self.currentDetail.cesMoult == null || self.currentDetail.cesMoult.length == 0){
					alert('Hodnota pole "Pelichání CES" musí být vyplněna');
					return false;
				}
				// ces habitat
				if (self.currentDetail.cesNetLength == null || self.currentDetail.cesNetLength.length == 0){
					alert('Hodnota pole "Délka sítí CES" musí být vyplněna');
					return false;
				}
				// ces net lenght
				if (self.currentDetail.cesHabitat == null || self.currentDetail.cesHabitat.length == 0){
					alert('Hodnota pole "Habitat CES" musí být vyplněna');
					return false;
				}
			}

			// RAS
			if (self.currentDetail.ras){
				// ras check number
				/*if (self.currentDetail.rasCheckNumber == null || self.currentDetail.rasCheckNumber.length == 0){
					alert('Hodnota pole "Číslo kontroly RAS" musí být vyplněna');
					return false;
				}*/
				// ras proj number
				if (self.currentDetail.rasProjNumber == null || self.currentDetail.rasProjNumber.length == 0){
					alert('Hodnota pole "Číslo lokality RAS" musí být vyplněna');
					return false;
				}
			}

			return true;
		}

			// delete detail
		this.deleteDetail = function(){
			if (self.currentDetail.id !== null){
				var ringnumber = (self.currentDetail.ringInformation < 3) ? self.currentDetail.ringType1.toUpperCase() + self.currentDetail.ringNumber1 : self.currentDetail.ringNumber1_retrap;
				//if (self)
				if(confirm('Opravdu chcete smazat záznam kroužku '+ringnumber+'?')){
					var id = self.currentDetail.id;
					var newringing = self.currentDetail.ringInformation < 4;
					var station = self.currentDetail.ringingScheme;
					var additionalUrl = '?id='+id+"&ringnumber="+ringnumber+"&ringing="+newringing+"&station="+station;
					var result = observationService.deleteRingItem(additionalUrl).then(
				  	function(result) {
				  	  if (typeof result.ok === 'undefined' || !result.ok){
				  	    alert("Chyba");
				  	  } else {
				  	  	alert('Záznam byl úspěšně smazán');
				  	  	var placeCode = self.currentDetail.placeCode;
				    		var netLength = self.currentDetail.netLength;
				    		self.currentDetail = new Observation($rootScope.user.rings.scheme);
				    		self.currentDetail.placeCode = placeCode;
				    		self.currentDetail.netLength = netLength;
				    		$rootScope.$broadcast('angucomplete-alt:clearInput');
				  	    // reload state without reloading the whole app
				  	    $rootScope.obsFormDirty = false;
				  	    $rootScope.detailFormDirty = false;
				  	    //$state.go('app.user.observation', {}, {reload: true});
				  	  }
				    }
				  );
				}
			} else {
			    if (confirm('Opravdu chcete vynulovat formulář? Všechna neuložená data budou ztracena')){
		    		var placeCode = self.currentDetail.placeCode;
		    		var netLength = self.currentDetail.netLength;
		    		self.currentDetail=new Observation($rootScope.user.rings.scheme);
		    		self.currentDetail.placeCode = placeCode;
		    		self.currentDetail.netLength = netLength;
		    		$rootScope.$broadcast('angucomplete-alt:clearInput');
				}
			}
		}

			// end inserting into details and redirect to observation page
		this.endDetail = function(){
			var lastRn = $filter('ringnumber')(self.details[self.details.length-1].ringNumber);
			var lng = self.details.length + (self.currentDetail.id ? 1 : 0);
			var msg = "Kroužkovací akce obsahuje " + lng + " záznamů, poslední uložený kroužek má číslo " + lastRn
									+". Přejete si kroužkovací akci ukončit? Data ve formuláři nebudou uložena.";
			if (confirm(msg)){
				var dataToSend = {
					Closed: 1,
					DateClosed: 'CURRENT_TIMESTAMP',
					Id: self.obsListId
				}
				$rootScope.obsFormDirty = false;
                $rootScope.detailFormDirty = false;

				var result = observationService.closeObsItems(dataToSend).then(
			  	function(result) {
			  	  if (typeof result.error !== 'undefined'){
			  	    alert("Chyba: " + result.error);
			  	  } else if (typeof result.ok !== 'undefined'){
			  	  	$rootScope.$broadcast('angucomplete-alt:clearInput');
			  	    if (self.q !== null){
			  	    	// redirect to moje zaznamy, if query is available
		  	    		self.doingSavingResolve = false;
		  	    		$state.go('app.user.records', {"q":self.q},{reload: true});
		  	    	} else {
			  	    	// reload state without reloading the whole app
		  	    		$rootScope.obsFormDirty = false;
			  	    	$rootScope.detailFormDirty = false;
			  	    	$state.go('app.user.observation', {}, {reload: true});
		  	    	}			  	    
			  	    		
			  	  } else {
			  	  	alert("Neznámá chyba: " + JSON.stringify(result));
			  	  }
			    });
			}
				
		}

		this.send = function(dataToSend){
			self.doingSavingResolve = true;
			var result = observationService.sendObsItem(dataToSend).then(
		  	function(result) {
		  		if (typeof result.error !== 'undefined'){
		  	 		switch (result.error) {
		  	 			case "RING_NOT_AVAILABLE":
		  	 				alert("Vybraný kroužek není k dispozici");
		  	 				self.doingSavingResolve = false;
		  	 				break;
		  	 			default:
		  	 				alert("Chyba: " + result.error);
		  	 				self.doingSavingResolve = false;
		  	 				break;
		  	 		}			
		  	 	} else if (typeof result.warning !== 'undefined'){
		  	 		if (confirm("U daného kroužku a dne jste již zaznamenal/a zpětný odchyt, chcete přesto uložit?")){
		  	 			dataToSend['ignoreWarning'] = true;
		  	 			self.send(dataToSend);
		  	 		}			  	    		
		  	 	} else if (typeof result.id !== 'undefined'){
		  	 		var ringingId = null;
		  	 		if (self.ringingInfo){
		  	 			ringingId = self.ringingInfo.ringItemId;
		  	 		}

		  	 		// offer automatic approval of retrap
		  	 		if (!self.currentDetail.id && ringingId && self.currentDetail.markType == 'A0'){
		  	 			var rn = self.currentDetail.ringNumber1_retrap;
				        if (rn.length == 10){
				          var rnparts = dissectRingNumber(rn);
				          if (rnparts && rnparts.length == 2){
				            rn = rnparts[0] + rnparts[1];
				          }
				        }
		  	 			if (confirm('Zaznamenali jste retrap vlastního kroužkovance. Přejete si retrap schválit a vygenerovat report?')){
			  	 			
	  	 				observationService.fetchRetrapHistory(rn,$rootScope.user.rings.scheme,'A0',null,null,self.ringingInfo.ringItemId,false)
	  	 					.then(function(data){
	  	 						var dataToSend = {
						          ID_Retrap: result.id,
						          RetrapApproved: 1,
						          ID_RetrapType: 'A',
						          ID_RetrapTypeSKB: 'A',
						          ID_Ringing: ringingId
						        }
						        //if (ringingId){
						        //dataToSend['ID_Ringing'] = ringingId;
						        //}
						        //console.log(dataToSend);
						        self.loading = true;
						        // update ID_OriginalRinging
						        observationService.updateRetrapItem(dataToSend,false,'id=ID_Retrap')
						          .then(function(data2){
						          	self.loading = false; 
						            self.showAlert  = true;
						            var body = {
						              id: result.id,
						              scheme: $rootScope.user.rings.scheme,
						              ringingscheme: $rootScope.user.rings.scheme,
						              code: rn,
						              metalring: rn,
						              method: 'A0',
						              lang: 'cz',
						              type: 'A',
						              items: data,
						              ownerScheme: $rootScope.user.rings.scheme
						            };
						            if ($rootScope.user.rings.scheme === 'SKB') {
						            	body.lang = 'sk';
						            }
						            observationService.generateRetrapPdf(body)
						              .then(function(data){
						                self.loading = false; 
						                self.showAlert  = true;
						              }, function(data3){
						                self.loading = false;
						                alert("Při načítání dat došlo k chybě");
						            });
						          });
		  	 					});
		  	 			}
		  	 		}

		  	 		// if the ObsList was closed, reload state, otherwise just add to the list of items
		  	 		if (dataToSend['close']){
		  	 			if (self.q !== null){
		  	 				self.doingSavingResolve = false;
		  	 				$state.go('app.user.records', {"q":self.q},{reload: true});
		  	 			} else {
		  	 				self.doingSavingResolve = false;
		  	 				$rootScope.obsFormDirty = false;
			    			$rootScope.detailFormDirty = false;
		  	 				// clear angucomplete input fields
				    		$rootScope.$broadcast('angucomplete-alt:clearInput');
			     			// reload state without reloading the whole app
			     			$state.go('app.user.observation', {}, {reload: true});
		  	 			}			  	    			
		  	 		} else {
		  	 			// push current detail to list of details
		  	 			self.currentDetail.id = result.id;
		  	 			var simplifiedDetail = {
			  	  			id: result.id,
			  	  			ringingScheme: self.currentDetail.ringingScheme,
			  	  			species: self.currentDetail.species.Fullname,
			  	  			sex: self.currentDetail.sex
			  	  		}
			  	    	// get age information object
			  	    	var ageinfo = self.codebook.age.reduce(function(a, b){
						    return (a.Id==self.currentDetail.age && a) || (b.Id == self.currentDetail.age && b)
						});
						simplifiedDetail.age = ageinfo.Name;
									// get sex
			  	    	switch (self.currentDetail.sex){
			  	    		case '1':
			  	    			simplifiedDetail.sex = 'M';
			  	    			break;
			  	    		case '2':
			  	    			simplifiedDetail.sex = 'F';
			  	    			break;
			  	    		case '5':
			  	    			simplifiedDetail.sex = 'U';
			  	    			break;
			  	    	}
			  	    	// get ring information object
			  	    	var rinfo = self.ringInformation.reduce(function(a, b){
						    return (a.code==self.currentDetail.ringInformation && a) || (b.code == self.currentDetail.ringInformation && b)
						});
									// get ring number
						simplifiedDetail.ringInformation = rinfo.description;
			  	    	switch (self.currentDetail.ringInformation){
			  	    		case 1:
			  	    			simplifiedDetail.ringNumber = self.currentDetail.ringType1 + self.currentDetail.ringNumber1;
			  	    			break;
			  	    		case 4:
			  	    			simplifiedDetail.ringNumber = self.currentDetail.ringNumber1_retrap;
			  	    			break;
			  	    		case 5:
			  	    			simplifiedDetail.ringNumber = self.currentDetail.ringNumber1_retrap + '/' + self.currentDetail.ringType2 + self.currentDetail.ringNumber2;
			  	    			break;
			  	    		case 6:
			  	    			simplifiedDetail.ringNumber = self.currentDetail.ringNumber1_retrap;
			  	    			break;
			  	    	}

						var found = false;
						for (var i = 0; i < self.details.length; i++){
							if (self.details[i].id == simplifiedDetail.id){
								self.details[i] = simplifiedDetail;
								found = true;
								break;
							}
						}

						if (!found){
							self.details.push(simplifiedDetail);
						}

		  	    		//self.details[self.currentDetail.id] = self.currentDetail;
		  	    		// create copy of detail and replace currentDetail with this copy
		  	    		if (dataToSend['copy']){
		  	    			var newDetail = self.currentDetail.copyOf();
		  	    			newDetail.ringTypeObj = angular.copy(self.currentDetail.ringTypeObj);
		  	    			self.currentDetail = newDetail;
		  	    			self.ringingInfo = null;
		  	    		} else {
		  	    			var placeCode = self.currentDetail.placeCode;
				    		var netLength = self.currentDetail.netLength;
				    		self.currentDetail=new Observation($rootScope.user.rings.scheme);
				    		self.currentDetail.placeCode = placeCode;
				    		self.currentDetail.netLength = netLength;
				    		$rootScope.$broadcast('angucomplete-alt:clearInput');
				    		self.ringingInfo = null;
		  	    		}
		  	    		// focus on ring type
		  	    		var element = $window.document.getElementById("ringtype");
		  	    		$timeout(function() {
			              element.focus();
			              self.repeated = true;
			            }); 										
		  	    		self.updateFamilies();
		  	    		self.updateRingTypes();
	  	    			//
	  	    			self.doingSavingResolve = false;
		  	    		self.showAlert = true;
		  	    		// scroll to message
		  	    		$location.hash('succesMessage');
		  	    		$anchorScroll();
		  	    		//$rootScope.$broadcast('angucomplete-alt:clearInput');
	  	    		}
			  	    		
	  	    	} else {
	  	    		alert("Neznámá chyba: " + JSON.stringify(result));
	  	    	}
	        });
		}

		// save to DB
		this.saveDetail = function(close,copy){
			if (self.validate()){
				self.currentDetail.obsListId = self.obsListId;
				var dataToSend = self.currentDetail;
				dataToSend['user'] = $rootScope.user;		
				dataToSend['close'] = close;
				dataToSend['copy'] = copy;
				dataToSend['date'] = self.date;
				dataToSend['scheme'] = $rootScope.user.rings.scheme;
				$rootScope.obsFormDirty = false;
	    		$rootScope.detailFormDirty = false;
				self.send(dataToSend);
			}
		}

			// are there any details?
	    self.showTable = function(){
	    	return Object.keys(self.details).length > 0;
	    }

	    // edit record - redirect
	    self.editRecord = function(idRecord){
		  	$state.go('app.user.observation.detail',{'id':idRecord},{ reload: true });
		  }

		  /* FILTERS */

	    // filter - return true if the species is wader, otherwise return false
	    self.filterPlumageCode = function() {
	      return function( plumageCode ) {
	      	if (self.currentDetail.species == null) {
	      		return !plumageCode.WadersOnly;							// species not selected - dont show waders
	      	} else {
	      		return plumageCode.WadersOnly <= self.currentDetail.species.IsWader;
	      	} 	        
	      };
	    };

	    // filter - return true if the species is wader, otherwise return false
	    self.filterEmpty = function() {
	      return function( item ) {
	      	return item.Name.length > 1;
	      };
	    };

	    // filter - return true if the species is wader, otherwise return false
	    self.filterParents = function() {
	      return function( item ) {
	      	return item.Code.indexOf('P') == -1;
	      };
	    };

	    this.searchFormatter = function(str){
				var userId = $rootScope.user.UID;
				return {s: str, id: userId};
			}

	  }
  }
}])
/*
* displays table with the records of certain user
*/
.directive('userRetraps', ['observationService','codebookService','ringsService'
  ,'locationService','$state','$rootScope','$q','myConfig','$uibModal',
  function(observationService,codebookService,ringsService
    ,locationService,$state,$rootScope,$q,myConfig,$uibModal){
  return {
    restrict: 'AE',
    templateUrl : 'pages/user-retraps.tpl.html',
    scope : {
      settings: '=',
      allUsers: '='
    },                                             // isolated scope
    controllerAs : 'UserRetrapsCtrl',
    bindToController: true,
    controller : function ($scope){
      
      // variables
      var self = this;
      // records
      self.records = null;
      self.numRecords = null;
      self.numRecordsPerPage = 100;
      self.datePicker1Opened = false;
      self.datePicker2Opened = false;
      self.doingResolve = false;
      self.noHistory = true;
      self.locations = [];
      self.selectedLocation = null;
      self.scheme = $rootScope.user.rings.scheme;
	  self.druhUrl = myConfig[self.scheme].druhUrl;
      self.obceUrl = myConfig[self.scheme].obceUrl;
      if (self.allUsers) {
      	self.additionalUrl = 'where=1';
      } else {
      	self.additionalUrl = 'where=(owner1 is ' + "'" + $rootScope.user.User + "' or owner2 is '" + $rootScope.user.User + "')";
      }
      self.ringInformation = [
        {"code": 1,"description": "Mé kroužkování"}
        ,{"code": 4,"description": "Můj nález"}];
      self.retrapType = [
        {"code": 'A',"description":  (self.scheme === 'CZP' ? "Český pták v ČR (A)" : "Slovenský pták v SR (A)")}
        ,{"code": 'C',"description": (self.scheme === 'CZP' ? "Cizí pták v ČR (C)" : "Cizí pták v SR (C)")}
        ,{"code": 'Z',"description": (self.scheme === 'CZP' ? "Český pták v zahraničí (Z)" : "Slovenský pták v zahraničí (Z)")}];
      self.query = {
        ringInformation: null,
        retrapType: null,
        dateFrom: null,
        dateTo: null,
        dateCreatedFrom: null,
        dateCreatedTo: null,
        location: null,
        species: null,
        municipality: null,
        ringNumber: null,
        scheme: null,
        county: null,
        country: null,
        licenceNumber: null
      }
      self.order = {
        retrapType: {
          asc: false,
          desc: false
        },
        date1: {
          asc: false,
          desc: false
        },
        date2: {
          asc: false,
          desc: false
        },
        dateCreated: {
          asc: false,
          desc: false
        },
        ringNumber: {
          asc: false,
          desc: false
        },
        species: {
          asc: false,
          desc: false
        },
        locality1: {
          asc: false,
          desc: false
        },
        locality2: {
          asc: false,
          desc: false
        },
        dist: {
          asc: false,
          desc: false
        },
        elapsed: {
          asc: false,
          desc: false
        },
        station1: {
          asc: false,
          desc: false
        }
      }
      // load locations
      // load data
      var userId = $rootScope.user.UID;
      var query = "UID=" + userId;
      //
      locationService.fetchUserLocations(query)
        .then(function(data){
          self.locations = data;          
        }, function(data){
          alert(data);
        });

      codebookService.fetchOkresy($rootScope.user.rings.scheme.substring(0,2))
        .then(function(data){
          self.okresy = data;
        }, function(data){
          alert("Při načítání dat došlo k chybě");
      });

      codebookService.fetchZeme()
      	.then(function(data){
      		self.zeme = data;
      	  },function(data){
      	  	alert("Při načítání dat došlo k chybě");
      	  });

      // load okresy codebook
      codebookService.fetchCodebook()
        .then(function(data){
          self.age = data.age;
          self.schemes = data.ringingscheme;
          self.primaryidentificationmethod = data.primaryidentificationmethod;
          self.circumstances = data.circumstances;
        }, function(data){
          alert("Při načítání dat došlo k chybě");
        });

      self.getHistory = function(){
        self.doingResolve = true;
        self.noHistory = false;
        observationService.fetchUserRetraps(1,self.numRecordsPerPage,self.constructUrl())
          .then(function(data){
            // reset additional URL, because it can be taken from url params
            self.records = data.items;
            self.numRecords = data.rowCount;
            self.doingResolve = false;
          }, function(data){
            self.doingResolve = false;
            alert("Při načítání dat došlo k chybě");
        });
      }

      self.getFileName = function(r) {
      	if (r.station2) {
      		return r.station2 + '_' + r.ringnumber + '.pdf';
      	} else {
      		return r.station1 + '_' + r.ringnumber + '.pdf';
      	}
      }

      // adds order to url
      self.constructOrder = function(){
        var url = "&order=";
        if (self.order.date1.asc){
          return url +='date1 asc';
        } else if (self.order.date1.desc){
          return url +='date1 desc';
        } else if (self.order.date2.asc){
          return url +='date2 asc';
        } else if (self.order.date2.desc){
          return url +='date2 desc';
        } else if (self.order.dateCreated.asc){
          return url +='dateCreated asc';
        } else if (self.order.dateCreated.desc){
          return url +='dateCreated desc';
        } else if (self.order.species.asc){
          return url +='species2 asc';
        } else if (self.order.species.desc){
          return url +='species2 desc';
        } else if (self.order.ringNumber.asc){
          return url +='ringnumber asc';
        } else if (self.order.ringNumber.desc){
          return url +='ringnumber desc';
        } else if (self.order.retrapType.asc){
          return url +='retrapType asc';
        } else if (self.order.retrapType.desc){
          return url +='retrapType desc';
        } else if (self.order.dist.asc){
          return url +='dist asc';
        } else if (self.order.dist.desc){
          return url +='dist desc';
        } else if (self.order.elapsed.asc){
          return url +='elapsed asc';
        } else if (self.order.elapsed.desc){
          return url +='elapsed desc';
        } else if (self.order.station1.asc){
          return url +='station1 asc';
        } else if (self.order.station1.desc){
          return url +='station1 desc';
        } else if (self.order.locality1.asc){
          return url +='locality1 asc';
        } else if (self.order.locality1.desc){
          return url +='locality1 desc';
        } else if (self.order.locality2.asc){
          return url +='locality2 asc';
        } else if (self.order.locality2.desc){
          return url +='locality2 desc';
        }
        return "";
      }    

      self.constructUrl = function(){
        if (self.query.ringInformation != null && self.query.ringInformation != ''){
          if (self.query.ringInformation == 1){
            url = "where=owner2 is '"+$rootScope.user.User+"'"
          } else {
            url = "where=owner1 is '"+$rootScope.user.User+"'"
          }
        } else {
          url = self.additionalUrl;
        }
        // add date, if set
        if ((self.query.dateFrom != null && self.query.dateFrom != '')
          || (self.query.dateTo != null && self.query.dateTo != '')){
          var dateFrom = '1000-01-01';
          var dateTo = '9999-12-31';
          if (self.query.dateFrom != null && self.query.dateFrom != ''){
            var dateFrom = yyyymmdd(self.query.dateFrom);
          }
          if (self.query.dateTo != null && self.query.dateTo != ''){
            var dateTo = yyyymmdd(self.query.dateTo);
          }
          url += " and date1 between '"  + dateFrom + "' and '" + dateTo + "'";
        }
         if ((self.query.dateCreatedFrom != null && self.query.dateCreatedFrom != '')
          || (self.query.dateCreatedTo != null && self.query.dateCreatedTo != '')){
          var dateCreatedFrom = '1000-01-01';
          var dateCreatedTo = '9999-12-31';
          if (self.query.dateCreatedFrom != null && self.query.dateCreatedFrom != ''){
            var dateCreatedFrom = yyyymmdd(self.query.dateCreatedFrom);
          }
          if (self.query.dateCreatedTo != null && self.query.dateCreatedTo != ''){
            var dateCreatedTo = yyyymmdd(self.query.dateCreatedTo);
          }
          url += " and dateCreated between '"  + dateCreatedFrom + "' and '" + dateCreatedTo + "'";
        }
        // species
        if (self.query.species != null){
          // taxonomic tree
          if (self.query.species.GenusId != 0){
            url += " and taxonid is " + self.query.species.TaxonID;
          } else if (self.query.species.FamilyId != 0){
            url += " and genusid is " + self.query.species.TaxonID;
          } else if (self.query.species.OrderId != 0){
            url += " and familyid is " + self.query.species.TaxonID;
          } else {
            url += " and orderid is " + self.query.species.TaxonID;
          }
        }
        // retrap type
        if (self.query.retrapType != null){
        	if (self.scheme === 'CZP') {
        		url += " and retrapType is '" + self.query.retrapType+"'";
        	} else if (self.scheme === 'SKB') {
        		url += " and retrapTypeSKB is '" + self.query.retrapType+"'";
        	}
        }
        // scheme
        if (self.query.scheme != null){
          url += " and (station1 is '" + self.query.scheme+"' or station2 is '" + self.query.scheme+"')";
        }
        // ringnumber
        if (self.query.ringNumber != null){
          var rn = self.query.ringNumber.replace(/\s/g,'');
          url += " and ringnumber is '" + rn + "'";
          /*var fullrn = fullRingNumber(rn);
          if (fullrn == rn || fullrn === null){
            url += " and ringnumber is '" + rn + "'";
          } else {
            url += " and (ringnumber is '" + rn + "' or ringnumber is '" + fullrn + "')";
          }*/
        }
        // location
        if (self.query.location != null && self.query.location != ''){
          url += " and (locality1 is '"  + self.query.location + "' or locality2 is '"+self.query.location+"')";
        }        
        // municipality
        if (self.query.municipality != null){
          url += " and (kodcobe1 is " + self.query.municipality+ " or kodcobe2 is "+self.query.municipality+")";
        }
        // okres
        if (self.query.county != null){
          url += " and (county1 is '" + self.query.county+ "' or county2 is '"+self.query.county+"')";
        }
        // zeme
        if (self.query.country != null){
          url += " and (country1 is '" + self.query.country+ "' or country2 is '"+self.query.country+"')";
        }
        // okolnosti
        if (self.query.circumstances != null) {
        	url += " and circumstances1 is '" + self.query.circumstances+ "'";
        }
        // licence
        if (self.query.licenceNumber != null) {
        	url += " and licenceNumber is '" + self.query.licenceNumber+ "'";
        }
        url  += '&scheme=' + self.scheme;
        // add order only of not already present
        if (url.indexOf('&order') === -1){
          url += self.constructOrder();
        }
        return url;
      }

      //self.getHistory();

      self.pageChanged = function(newPageNumber){
        self.doingResolve = true;
        observationService.fetchUserRetraps(newPageNumber,self.numRecordsPerPage,self.constructUrl())
        .then(function(data){
          self.doingResolve = false;
          self.records = data.items;
          self.numRecords = data.rowCount;
        }, function(data){
          self.doingResolve = false;
          alert("Při načítání dat došlo k chybě");
        });
      }

      // get class of row
      self.rowClass = function(type){
        switch(type){
          case 'A':
            return 'success'
          case 'C':
            return 'warning';
          case 'Z':
            return 'info';
          case 'X':
            return 'error';
          default:
            return null;
        }
      }

      // reset all form options
      self.resetForm = function(){
        self.query = {
          ringInformation: null,
          retrapType: null,
          dateFrom: null,
          dateTo: null,
          dateCreatedFrom: null,
          dateCreatedTo: null,
          location: null,
          species: null,
          municipality: null,
          ringNumber: null,
          licenceNumber: null
        }
        // reset autocompleter
        $rootScope.$broadcast('angucomplete-alt:clearInput');
      }
      // resets order of columns
      self.resetOrder = function(){
        self.order = {
          retrapType: {
            asc: false,
            desc: false
          },
          date1: {
            asc: false,
            desc: false
          },
          date2: {
            asc: false,
            desc: false
          },
          dateCreated: {
            asc: false,
            desc: false
          },
          ringNumber: {
            asc: false,
            desc: false
          },
          species: {
            asc: false,
            desc: false
          },
          locality1: {
            asc: false,
            desc: false
          },
          locality2: {
            asc: false,
            desc: false
          },
          dist: {
            asc: false,
            desc: false
          },
          elapsed: {
            asc: false,
            desc: false
          },
          station1: {
            asc: false,
            desc: false
          }
        }
      }

      self.changeOrder = function(type){
        var asc = self.order[type].asc;
        self.resetOrder();
        if (asc){
          self.order[type].desc = true;
        } else {
          self.order[type].asc = true;
        }
        self.getHistory();
      }

      self.openDatePicker = function(val){
         if (val == 1){
          self.datePicker1Opened = true;
         } else if (val == 2){
          self.datePicker2Opened = true;
         } else if (val == 3){
          self.datePicker3Opened = true;
         } else if (val == 4){
          self.datePicker4Opened = true;
         }
      }

      // when autocompleter option for species is selected, update model
      this.updateSpecies = function (selectedValue) {
        // if the user clears the input box        
        if (!selectedValue) {
            self.query.species = null;
            return;
        }
        self.query.species = selectedValue.originalObject; 
      };

      // when autocompleter option for municipality is selected, update model
      this.updateMunicipality = function (selectedValue) {
        if (!selectedValue) {
            self.query.municipality = null;
            return;
            }
            if (selectedValue) {
              self.query.municipality = selectedValue.originalObject.ID;
            }
      };

      self.selectLocation = function(){
        if (self.selectedLocation){
          self.query.municipality = self.selectedLocation.ID_MunicipalityPart;
          self.query.location = self.selectedLocation.Name;
          $scope.$broadcast('angucomplete-alt:changeInput', 'municipalityId', self.selectedLocation.Municipality);
        }
      }  

      // path to url saved on server
      self.pdfUrl = function(path){
      	var url = 'https://rings.birds.cz/userdata/rings/reports/' + path;
        //var url = myConfig.apiUrl.replace('v1/','userdata/rings/reports/'+path);
        return url;
      }

      // header of csv file
      self.getHeaderRecords = function(){
        return ["Číslo kroužku","Číslo kroužku ZH","Stanice","Druh ZH","Druh(lat) ZH","Druh K","Druh(lat) K","Datum K","Čas K","Místo K","Obec K","Okres K","Kraj K","Stát K"
        ,"X K","Y K","Kroužkoval","Datum ZH","Čas ZH","Místo ZH","Obec ZH","Okres ZH","Kraj ZH","Stát ZH","X ZH","Y ZH"
        ,"Nálezce","Spolupozorovatel","Vzdálenost","Dní","Typ retrapu","Věk K","Věk ZH","Pohlaví K","Pohlaví ZH"
        ,"Nažina K","Nažina ZH","Tuk K","Tuk ZH","Okolnosti K","Okolnosti ZK","Okolnosti kód K","Okolnosti kód ZK","Kondice K","Kondice ZH"
        ,"Hmotnost K","Hmotnost ZH","Křidlo K","Křídlo ZK","Směr"];
      }

      self.getColumnsRecords = function(){
        return ['ringnumber','ringnumberZH','station1','species','speciesLat','species2','speciesLat2','date2','measurementTime2','locality2','municipality2','county2','kraj2','country2'
        ,'lat2','lon2','ownerName2','date1','measurementTime1','locality1','municipality1'
        ,'county1','kraj1','country1','lat1','lon1','ownerName1','coobservers1','dist','elapsed','retrapType','age2','age1','sex2','sex1'
        ,'broodPatch2','broodPatch1','fat2','fat1','circumstancesCz2','circumstancesCz1','circumstances2','circumstances1','condition2','condition1'
        ,'mass2','mass1','wingLength2','wingLength1','bearing'];
      }


      // export table as csv
      self.exportCsvRecords = function(){
        //return self.records;   
        var deferred = $q.defer();
        self.doingResolve = true;
        observationService.fetchUserRetraps(1,null,self.constructUrl())
          .then(function(data){
            deferred.resolve(data.items);    
            self.doingResolve = false;
          }, function(data){
            self.doingResolve = false;
            alert("Při načítání dat došlo k chybě");
          });
        return deferred.promise;
      }

      self.showDetail = function(rec) {
        var modalScope = $scope.$new();

        self.retrapRecord = rec;

        self.modalInstance = $uibModal.open({
        template: '<user-retrap-modal-window record="UserRetrapsCtrl.retrapRecord" instance="UserRetrapsCtrl.modalInstance"></user-retrap-modal-window>',
          size: 'lg',
          scope: modalScope
        });

        self.modalInstance.result.then(function (selectedItem) {
            //console.log('close');
          }, function () {
            //$log.info('Modal dismissed at: ' + new Date());
           //console.log('dismiss');
          });
      };
      
    }
  }
}])
/*user detail modal window*/
.directive('selectFamilyModalWindow',['$rootScope','familyService'
  ,function($rootScope, familyService){
  return {
    restrict : 'E',
    templateUrl : 'templates/select-family-modal.tpl.html',
    scope : { 
      instance: "=",
    },
    controllerAs : 'SelectFamilyModalWindowCtrl',
    bindToController: true,
    controller : function ($scope){

      var self = this;
      self.selected = null;
      self.doingResolve = true;

      var userId = $rootScope.user.UID;
		var additionalUrl = '?where=userid is ' + userId;
	    familyService.fetchFamilies(additionalUrl)
		  .then(function(data){
		  	self.doingResolve = false;
		    self.families = data;
		  }, function(data){
		  	self.doingResolve = false;
		    alert("Při načítání dat došlo k chybě");
		});

      self.cancel = function(){
        self.instance.dismiss();
      }

      self.close = function(){
        self.instance.close(self.selected);
      }

    }  

  }
}])
/*user detail modal window*/
.controller('informationConfirmationModalWindow',['$rootScope','$uibModalInstance'
  ,function($rootScope,$uibModalInstance){
  $rootScope.ok = function () {
    $uibModalInstance.close($scope.selected.item);
  };

  $rootScope.cancel = function () {
    $uibModalInstance.dismiss('cancel');
  };
}])
/*user detail modal window*/
.directive('ringingInfoModalWindow',['$rootScope','amMoment'
  ,function($rootScope,amMoment){
  return {
    restrict : 'E',
    templateUrl : 'templates/ringing-info-modal.tpl.html',
    scope : { 
      ringing : '=',
      retraps: "=",
      instance: "=",
    },
    controllerAs : 'ModalRingingInfoCtrl',
    bindToController: true,
    controller : function ($scope){

      var self = this;
      self.scheme = $rootScope.user.rings.scheme;
      self.speciesName = 'speciesName';
      if (self.scheme === 'SKB') {
      	self.speciesName = 'speciesNameSK';
      }

      console.log(self.scheme, self.speciesName);

      self.cancel = function(){
        self.instance.close();
      }

    }  

  }
}])
/*
* table of additional marks
*/
.directive('additionalMarks', [function(){
  return {
    restrict: 'E',
    templateUrl : 'pages/additional-marks.tpl.html',
    scope : {
    	marks: "=",
    	ringinformation: "=",
    	ringtypes: "=",
    	codebook: "=",
    	ngDisabled: "="
    }, // isolated scope
    controllerAs : 'AddMarksCtrl',
    bindToController: true,
    controller : function (){

    	// variables
    	var self = this;   
    	self.currentMark = null;

    	// functions

    	// after click on additional mark set delete it
	    self.removeAdditionalMark = function(mark) {
	      if (confirm('Opravdu chcete smazat identifikační značku?')) {
	        //delete self.marks[mark.uuid];
	        self.marks = self.marks.filter(function (el) {
                        return el !== mark;
                       });
	      }
	    }

	    // update ring number when the ring type changes
	    self.changeRingType = function(mark){
    	if (mark.markType == 'A0' && mark.ringInformation == 1) {
	    		for (var i = 0; i < self.ringtypes.length; i++){
			      if (self.ringtypes[i] 
			      	&& self.ringtypes[i].ID_RingType == mark.ringTypeObj.ID_RingType
			      	&& self.ringtypes[i].min == mark.ringTypeObj.min){
			      	mark.ringType = self.ringtypes[i].ID_RingType;
			      	mark.ringNumber = self.ringtypes[i].min;
			      }
			    }
	    	}	    	
	    }

	    // if type is 'new ringing'
    	this.changeRingingInformation = function(mark) {
	      if (mark.ringInformation == 1) {
	        mark.ringingScheme = self.scheme;
	      }
	    }

	    // return class for color - required based on markType
			this.colorRequired = function(mark){
				if (['B0','C0','D0','H0'].indexOf(mark.markType) != -1){
					return 'required';
				} else {
					return null;
				}
			}

	    // add identification mark
	    self.addIdentificationMark = function() {
				self.marks.push(new Mark());      
	    }
	  }
  }
}])
/*
* download pdf
*/
.directive('pdfDownload', function() {
    return {
        restrict: 'E',
        template: '<a href="{{pdfDownloadController.pdfUrl}}" download="{{pdfDownloadController.filename}}"><span class="glyphicon glyphicon-file"></span></a>',
        scope : {
	    	url : "=",
	    	filename : '='
	    },
	    controllerAs : 'pdfDownloadController',
    	bindToController: true,
        controller: [function() {
        	var randomint = Math.floor(Math.random() * (1000));
        	this.pdfUrl = 'https://rings.birds.cz/userdata/rings/reports/' + this.url + '?' + randomint;
        	if (!this.filename) {
        		this.filename = 'report.pdf';
        	}
            /*$scope.downloadPdf = function() {
                $scope.$emit('download-start');
                $http.get($attrs.url).then(function(response) {
                    $scope.$emit('downloaded', response.data);
                });
            };*/
        }]
      }
})
/*
* loads number of ringorders to be processed and inserts them into html as badge
*/
.directive('nRingOrders', ['$interval','ringsService',function($interval,ringsService){
  return {
    restrict: 'AE',
    //template : '&nbsp;<span class="badge" ng-show="val == 1 &&ringsService.ringorders.created > 0">{{ringsService.ringorders.created}}</span>',
    templateUrl : 'pages/n-ring-orders.tpl.html',
    scope : {
    	val : "="
    },
    controllerAs : 'nRingOrdersCtrl',
    bindToController: true,
    controller : function ($scope){

    	$scope.ringsService = ringsService;

    	//ringsService.updateNRingOrders();
    	ringsService.doPeriodicUpdate();

	  }
  }
}])
/*
* confirmation alert, which dissapears itself
*/
.directive('confirmation', function(){
  return {
    restrict: 'E',
    templateUrl : 'pages/confirmation.tpl.html',
    scope : {
    	showAlert : "="
    },
    controllerAs : 'confirmationCtrl',
    bindToController: true,
    controller : function ($scope){

    	var self = this;

    	self.hideAlert = function(){
    		self.showAlert = false;
    	}

	  }
  }
})
/*
* nodata alert, which dissapears itself
*/
.directive('nodata', function(){
  return {
    restrict: 'E',
    templateUrl : 'pages/nodata.tpl.html',
    scope : {
    	showAlert : "="
    },
    controllerAs : 'nodataCtrl',
    bindToController: true,
    controller : function ($scope){

    	var self = this;

    	self.hideAlert = function(){
    		self.showAlert = false;
    	}

	  }
  }
})
/*
* custom time picker
*/
.directive('timePicker', function($timeout) {
    return {
    restrict: 'E',
    templateUrl : 'pages/time-picker.tpl.html',
    scope : {
    	time : "=ngModel",
    	disabled : "=ngDisabled"
    },
    controllerAs : 'timePickerCtrl',
    bindToController: true,
    controller : function ($scope){

    	var self = this;
    	if (typeof(self.time) === "undefined" || self.time == null){
    		self.h = null;
    		self.m = null;
    	} else {
    		var splitted = self.time.split(':');
    		if (splitted.length >= 2){
    			self.h = parseInt(splitted[0],10);
    			if (splitted[1] != ''){
	    			self.m = parseInt(splitted[1],10);
	    		}	    			
    		} else if (splitted.length == 1) {
    			self.h = parseInt(splitted[0],10);
    		}	
    	}

	  },
	  link: function (scope, element, attrs, ctrl) {

	  	scope.$watch('timePickerCtrl.h', function() {
	  		if (ctrl.h != null && ctrl.m != null){
	  			ctrl.time = ("0" + ctrl.h).slice(-2) + ":" + ("0" + ctrl.m).slice(-2);
	  		}        
      });

	  	scope.$watch('timePickerCtrl.m', function() {
	  		if (ctrl.h != null && ctrl.m != null){
	  			ctrl.time = ctrl.h + ":" + ctrl.m;
	  			ctrl.time = ("0" + ctrl.h).slice(-2) + ":" + ("0" + ctrl.m).slice(-2);
	  		}        
      });

      scope.$parent.$watch(attrs.ngModel, function() {
        if (typeof(ctrl.time) === "undefined" || ctrl.time == null){
	    		ctrl.h = null;
	    		ctrl.m = null;
	    	} else {
	    		var splitted = ctrl.time.split(':');
	    		if (splitted.length == 2){
	    			ctrl.h = parseInt(splitted[0],10);
	    			if (splitted[1] != ''){
	    				ctrl.m = parseInt(splitted[1],10);
	    			}	    			
	    		} else if (splitted.length == 1) {
	    			ctrl.h = parseInt(splitted[0],10);
	    		}	
	    	}
      });
    }
  }
})
/*
* Directive to display form to change the user
*/
.directive('reportSpecies', ['$rootScope','observationService','locationService'
	,function($rootScope,observationService,locationService){
  return {
    restrict: 'E',
    templateUrl : 'pages/report-species.tpl.html',
    scope : { 
      allusers : '=',
      withLocations : '='
    },                                            // isolated scope
    controllerAs : 'ReportSpeciesCtrl',
    bindToController: true,
    controller : function ($scope){

      // variables
      var self = this;
      // records
      self.datePicker1Opened = false;
      self.datePicker2Opened = false;
      self.doingResolve = false;
      self.sortColumn = 'spec';
      self.sortAscending = false;
      self.query = {
        dateFromS: new Date(new Date().getFullYear(), 0, 1,12,0,0),
        dateToS: new Date(),
      }

      // load list of locations from server
      if (self.withLocations){
      	  var userId = $rootScope.user.UID;
	      var query = "UID=" + userId;
		  locationService.fetchUserLocations(query)
		    .then(function(data){
		      self.locations = data;
		    }, function(data){
		      alert(data);
		  });
      }
      

      // create url string for summary
      self.constructSummaryUrl = function(){
        var url = '';
        if ( !self.allusers ) {
          url = 'owner='+"'" + $rootScope.user.User + "'&";
        }
        if ( self.withLocations && self.query.location ) {
          url += 'location='+"'" + self.query.location + "'&";
        }
        if ((self.query.dateFromS != null && self.query.dateFromS != '')
          || (self.query.dateToS != null && self.query.dateToS != '')){
          var dateFrom = '1000-01-01';
          var dateTo = '9999-12-31';
          if (self.query.dateFromS != null && self.query.dateFromS != ''){
            var dateFrom = yyyymmdd(self.query.dateFromS);
          }
          if (self.query.dateToS != null && self.query.dateToS != ''){
            var dateTo = yyyymmdd(self.query.dateToS);
          }
          url += "from='" + dateFrom + "'&to='" + dateTo + "'";
          //url += " and date between '"  + dateFrom + "' and '" + dateTo + "'";
        }
        url += '&scheme=' + $rootScope.user.rings.scheme;
        return url;
      }

      // when location is selected, update query.location
      self.selectLocation = function(){
        if (self.selectedLocation){
          self.query.location = self.selectedLocation.Name;
        } else {
          self.query.location = null;
        }
      }

      // sum of rings in order
      self.getTotalSummaryItems = function(){
        self.summaryStats = {
          species:null,
          total:null,
          pull:null,
          ad:null,
          retrap:null
        }
        for (var i = 0; i < self.summary.length; i++){
          self.summaryStats.species += 1;
          self.summaryStats.total += self.summary[i].total;
          self.summaryStats.pull += self.summary[i].pull;
          self.summaryStats.ad += self.summary[i].ad;
          self.summaryStats.retrap += self.summary[i].retrap;
        }
      }

      self.openDatePicker = function(val){
         if (val == 1){
          self.datePicker1Opened = true;
         } else if (val == 2){
          self.datePicker2Opened = true;
         }
      }

      // get summary
      self.getSummary = function(){
        self.doingResolve = true;
        observationService.fetchSummary(self.constructSummaryUrl())
          .then(function(data){
          	console.log(data);
            self.summary = data;
            self.getTotalSummaryItems();
            self.doingResolve = false;
          }, function(data){
            self.doingResolve = false;
            alert("Při načítání dat došlo k chybě");
        });
      }

      // header of csv file
      self.getHeader = function(){
        return ['Druh','Celkem','pull','ostatní','retrapy'];
      }

      self.getColumns = function(){
        return ['spec','total','pull','ad','retrap'];
      }

      // export table as csv
      self.exportCsv = function(){
        var output = angular.copy(self.summary);
        //self.getTotalSummaryItems();
        var total = {
          spec: self.summaryStats.species + ' druhů',
          total: self.summaryStats.pull + self.summaryStats.ad,
          pull: self.summaryStats.pull,
          ad: self.summaryStats.ad,
          retrap: self.summaryStats.retrap,
        }
        output.push(total)
        return output;
      }

       // header of csv file
      self.getHeaderRecords = function(){
        return ['Datum','Číslo kroužku','Délka sítí','Stanice','Druh','Druh(lat)'
        ,'Info','Typ značky','Lokalita','Obec','Okres','Region','Věk','Pohlaví'
        ,'Kondice','Okolnosti','Délka křídla','Třetí ruční letka','Stav vrcholu křídla','Hmotnost','Čas odchytu'
        ,'Pelichání','Šat','Zadní dráp','Délka zobáku','Metoda měření zobáku','Délka hlavy','Tarsus','Metoda měření tarsu'
        ,'Délka ocase','Rozdíl délky RP','Tuk','Prsní svaly','Hnízdní nažina','Holina','Staré LK'
        ,'Zápěstní krovka','Pelichání RL','Pelichání LL','Alula',"Typ př. značky","Info př. značky","Barva př. značky"
        ,"Stanice př. značky","Číslo př. značky"];
      }

      self.getColumnsRecords = function(){
        return ['dateExport','ringnumber','netLength','station','species','speciesLat'
        ,'operation','methodName','locality','municipality','county','place','age','sex'
        ,'cond','circumstances','wingLength','thirdPrimary','stateOfWingPoint','mass','measurementTime'
        ,'moult','plumageCode','hindClaw','billLength','billMethod','totalHeadLength','tarsus','tarsusMethod'
        ,'tailLength','tailDifference','fatScore','pectoralMuscleScore','broodPatch','juvenilePatch','oldGreatedCoverts'
        ,'carpalCoverts','primaryMoult','secondaryMoult','alula',"mrkMarkType","mrkIdOperation","mrkColor"
        ,"mrkStation","mrkRingnumber"];
      }


      // export table as csv
      self.exportCsvRecords = function(){
        //return self.records;   
        var deferred = $q.defer();
        self.doingResolve = true;
        observationService.fetchFullObservationOverview(self.constructUrl())
          .then(function(data){
            deferred.resolve(data);    
            self.doingResolve = false;
          }, function(data){
            self.doingResolve = false;
            alert("Při načítání dat došlo k chybě");
          });
        return deferred.promise;
      }
    }
  }
}])
/*
* Directive to display form to change the user
*/
.directive('speciesChart', ['observationService','$rootScope','myConfig'
	,function(observationService, $rootScope,myConfig){
  return {
    restrict: 'E',
    templateUrl : 'pages/species-chart.tpl.html',
    scope : {},                                            // isolated scope
    controllerAs : 'SpeciesChartCtrl',
    bindToController: true,
    controller : function ($scope){

      // variables
      var self = this;
      // autocomplete
      self.scheme = $rootScope.user.rings.scheme;
      self.druhUrl = myConfig[self.scheme].druhUrl;
      // records
      self.datePicker1Opened = false;
      self.datePicker2Opened = false;
      self.doingResolve = false;
      self.query = {
        dateFromS: new Date(new Date().getFullYear(), 0, 1, 12, 0, 0),
        dateToS: new Date(),
        species: null,
        user: $rootScope.user.User
      }

      // options - colors
      self.chartColors = ['#97BBCD', // blue
      					  '#F7464A', // red
      					  '#DCDCDC', // light grey
      					  '#46BFBD', // green					    
					    '#FDB45C', // yellow
					    '#949FB1', // grey
						'#4D5360' // dark grey
						];

      // options - bar chart
      self.rinfOptions = {
	      legend: {
	        display: false
	      },                                                                                             
	      scales: {
	        yAxes: [{id: 'y-axis-1', type: 'linear', position: 'left', ticks: {min: 0}}]
	      }
	    };
	  // options - pie charts
	  self.pieOptions = {
	  	legend: {
	        display: true,
	        position: 'right'
	      }
	  }


      this.updateSpecies = function (selectedValue) {
        // if the user clears the input box        
        if (!selectedValue) {
            self.query.species = null;
            return;
        }
        self.query.species = selectedValue.originalObject.TaxonID;
      };   

      // create url string for summary
      self.constructChartUrl = function(){
        var url = '';
        url = '?user='+ self.query.user + "&";
        if ( self.query.species ) {
          url += 'species='+ self.query.species + "&";
        }
        if ((self.query.dateFromS != null && self.query.dateFromS != '')
          || (self.query.dateToS != null && self.query.dateToS != '')){
          var dateFrom = '1000-01-01';
          var dateTo = '9999-12-31';
          if (self.query.dateFromS != null && self.query.dateFromS != ''){
            var dateFrom = yyyymmdd(self.query.dateFromS);
          }
          if (self.query.dateToS != null && self.query.dateToS != ''){
            var dateTo = yyyymmdd(self.query.dateToS);
          }
          url += "from=" + dateFrom + "&to=" + dateTo;
          //url += " and date between '"  + dateFrom + "' and '" + dateTo + "'";
        }
        return url;
      }


      self.openDatePicker = function(val){
         if (val == 1){
          self.datePicker1Opened = true;
         } else if (val == 2){
          self.datePicker2Opened = true;
         }
      }

      // get summary
      self.getChartData = function(){
        self.doingResolve = true;
        observationService.fetchChartData(self.constructChartUrl())
        .then(function(data){
        	self.doingResolve = false;
        	self.showCharts = true;	
        	self.processRinfo(data.rinfoCnt);
        	self.processSex(data.sexCnt);
        	self.processAge(data.ageCnt);
        	self.biomStats = data.biomStats[0];
        });
      };

      // fill rinfo from data
      self.processRinfo = function(arr) {
      	self.rinfo = {
      		K: 0,
      		ZH: 0
      	}
      	angular.forEach(arr,function(item) {
      		self.rinfo[item.rinfo] = parseInt(item.cnt);
      	});
      	self.rinfoData = [self.rinfo.K, self.rinfo.ZH];
      }

      // fill rinfo from data
      self.processSex = function(arr) {
      	self.sex = {
      		M: 0,
      		F: 0,
      		U: 0,
      	}
      	angular.forEach(arr,function(item) {
      		self.sex[item.sex] = parseInt(item.cnt);
      	});
      	self.sexData = [self.sex.M, self.sex.F, self.sex.U];
      }

      // fill rinfo from data
      self.processAge = function(arr) {
      	self.ageData = [];
      	self.ageLabels = [];
      	
      	angular.forEach(arr,function(item) {
      		self.ageData.push(item.cnt);
      		self.ageLabels.push(item.age);
      	});
      }



    }
  }
}])
/*
* review of ring families
*/
.directive('familyRecords', ['$rootScope','familyService','$filter','myConfig'
	,function($rootScope,familyService,$filter,myConfig){
  return {
    restrict: 'E',
    templateUrl : 'pages/family-records.tpl.html',
    scope : { 
      oneuser : '='
    },                                            // isolated scope
    controllerAs : 'FamilyRecordsCtrl',
    bindToController: true,
    controller : function ($scope){

      // variables
      var self = this;
      self.scheme = $rootScope.user.rings.scheme;
      self.userUrl = myConfig[self.scheme].userUrl;
	  self.druhUrl = myConfig[self.scheme].druhUrl;
      // loading
      self.doingResolve = false;
      self.nodata = false;
      // query
      self.datePicker1Opened = false;
      self.datePicker2Opened = false;
      
      self.query = {
        dateFromS: null,
        dateToS: null,
        species: null,
        userid: null,
        onlyFamilies: "families"
      }

      self.search = {
      	nestNumber: '',
      }

      self.url = "?where=ringerScheme is '" + self.scheme + "'";

      // if not all users, then 
      if ( self.oneuser ) {
      	self.url += " and userid is "+$rootScope.user.UID;
      }

      // when autocompleter option for species is selected, update model
      this.updateSpecies = function (selectedValue) {
        // if the user clears the input box        
        if (!selectedValue) {
            self.query.species = null;
            return;
        }
        self.query.species = selectedValue.originalObject; 
      };

      // when autocompleter option for ringer is selected, update model
      self.updateRinger = function (selectedValue) {
        // if the user clears the input box        
        if (!selectedValue) {
          self.query.userid = null;
          return;
        }
        self.query.userid = selectedValue.originalObject.UID;
      };

      // reset form
      self.resetForm = function() {
      	self.query = {
	        dateFromS: null,
	        dateToS: null,
	        species: null,
	        userid: null
	     }
      }

      self.closeFamily = function(fi){
      	var dataToSend = {
      		ID: fi.idFamily ? fi.idFamily : fi.ID,
      		Closed: 1
      	}
      	familyService.updateFamily(dataToSend)
	      	.then(function(data){
	      		self.fetchFamilyView();
	      		//console.log(data);
	      	})
      }

      // generic function to sum values in array of objects
      self.sum = function(arr,val){
      	if ( typeof arr === 'undefined' ) {
      		return null;
      	}
        return arr.reduce( function(a, b){
          return a + b[val];
        }, 0);
      }

      // create url string for summary
      self.constructUrl = function(){
        var url = this.url;
        if ( !self.oneuser ) {
        	if (self.query.userid) {
        		url += ' and userid='+"'" + self.query.userid + "'";
        	}          
        }
        if ((self.query.dateFromS != null && self.query.dateFromS != '')
          || (self.query.dateToS != null && self.query.dateToS != '')){
          var dateFrom = '1000-01-01';
          var dateTo = '9999-12-31';
          if (self.query.dateFromS != null && self.query.dateFromS != ''){
            var dateFrom = yyyymmdd(self.query.dateFromS);
          }
          if (self.query.dateToS != null && self.query.dateToS != ''){
            var dateTo = yyyymmdd(self.query.dateToS);
          }
          if ( url.length > 0 ) {
          	url += " and "
          }
          url += "datum >='" + dateFrom + "' and datum <='" + dateTo + "'";
          //url += " and date between '"  + dateFrom + "' and '" + dateTo + "'";
        }
        if (self.query.species != null){
          // taxonomic tree
          if (self.query.species.GenusId != 0){
            url += " and taxonid is " + self.query.species.TaxonID;
          } else if (self.query.species.FamilyId != 0){
            url += " and genusid is " + self.query.species.TaxonID;
          } else if (self.query.species.OrderId != 0){
            url += " and familyid is " + self.query.species.TaxonID;
          } else {
            url += " and orderid is " + self.query.species.TaxonID;
          }
        }
        return url;
      }

      self.openDatePicker = function(val){
         if (val == 1){
          self.datePicker1Opened = true;
         } else if (val == 2){
          self.datePicker2Opened = true;
         }
      }

      // get summary
      self.fetchFamilyView = function(){
        self.doingResolve = true;
        if (self.query.onlyFamilies === "all") {
        	familyService.fetchFamilyView(self.constructUrl())
	          .then(function(data){
	          	self.records = data;
	          	self.families = [];
	          	if (data.length === 0) {
	          		self.showAlert = true;
	          	}
	            self.doingResolve = false;
	          }, function(data){
	            self.doingResolve = false;
	            alert("Při načítání dat došlo k chybě");
	        });
	      } else {
	      	familyService.fetchFamilies(self.constructUrl())
	          .then(function(data){
	          	console.log(data);
	          	self.families = data;
	          	self.records = [];
	          	if (data.length === 0) {
	          		self.showAlert = true;
	          	}
	            self.doingResolve = false;
	          }, function(data){
	            self.doingResolve = false;
	            alert("Při načítání dat došlo k chybě");
	        });
	      }
        
      }

      self.exportCsvRecords = function(){
      	var results = [];
      	if (self.query.onlyFamilies === "all"){
	        for (var i = 0; i<self.records.length; i++){
	          results[i] = {
	          	Datum: $filter('amDateFormat')(self.records[i]['datum'],'D.M.YYYY'),
	            FamilyId: self.records[i]['idFamily'],
	            NestNumber: self.records[i]['nestNumber'],
	            RingNumber: self.records[i]['ringNumber'],
	            Species: self.records[i]['species'],
	            Role: $filter('familyrole')(self.records[i]['role']),
	            Locality: self.records[i]['locality']+" ("+self.records[i]['nazcobe']+")",
	            NumBirds: self.records[i]['numBirds'],
	            Ringed: self.records[i]['ringed'],
	            Name: self.records[i]['name'] + " " + self.records[i]['surname']
	          }
	        }
	        return results;
      	} else {
      		for (var i = 0; i<self.families.length; i++){
	          results[i] = {
	          	Datum: $filter('amDateFormat')(self.families[i]['datum'],'D.M.YYYY'),
	            FamilyId: self.families[i]['ID'],
	            NestNumber: self.families[i]['nestNumber'],
	            Species: self.families[i]['species'],
	            Locality: self.families[i]['locality']+" ("+self.families[i]['nazcobe']+")",
	            NumBirds: self.families[i]['NumBirds'],
	            Ringed: self.families[i]['ringed'],
	            Name: self.families[i]['name'] + " " + self.families[i]['surname'],
	            Longitude: self.families[i]['longitude'],
	            Latitude: self.families[i]['latitude']
	          }
	        }
	        return results;
      	}
      }

      self.getHeaderRecords = function(){
      	if (self.query.onlyFamilies === "all"){
      		return ['Datum','ID Rodiny','Číslo hnízda','Kroužek','Druh','Role','Lokalita','Mláďat v hnízdě','Okroužkovaných mláďat','Kroužkovatel'];
      	} else {
      		return ['Datum','ID Rodiny','Číslo hnízda','Druh','Lokalita','Mláďat v hnízdě','Okroužkovaných mláďat','Kroužkovatel','X','Y'];
      	}
      }
    }
  }
}]);

